import React, { useEffect, useRef, useState } from "react";
import PurposeScore from "./PurposeScore/PurposeScore";
import Summary from "./Summary/Summary";
import Details from "./Details/Details";
import Objective from "./Objective/Objective";
import Stakeholders from "./Stakeholders/Stakeholders";
import Risks from "./Risks/Risks";
import Team from "./Team/Team";
import Target from "./Target/Target";
import ActivityPlannar from "./ActivityPlannar/ActivityPlannar";
// import TabMenuElement from "../../../Components/UiComponents/TabMenuElement";
import { getField, getTable } from "../../../Services/tooltipService";
import _ from "lodash";
import { getCustomer } from "../../../Services/customerServices";
import { useLocation, useNavigate } from "react-router-dom";
import { get, getOppAccess, saveStage, update } from "../../../Services/opportunityService";
import { useIsEdited } from "../../../Providers/IsEditedProvider";
import { Toast } from "primereact/toast";
import {
  getModulePermissions,
  getPlanDetails,
} from "../../../Services/pricingPlanService";
import { userPrivilleges } from "../../../Services/userService";
import { all } from "../../../Services/frameworkService";
import { getCustomerTable } from "../../../Services/clientService";
import RelationshipManager from "./RelationshipManager/RelationshipManager";
import { get as getClients } from "../../../Services/clientService";
import { get as getUsers } from "../../../Services/userService";
import PromptsAndChecklists from "./PromptsAndChecklists/PromptsAndChecklists";
import ReviewAndGovernance from "./ReviewAndGovernance/ReviewAndGovernance";
import Avatar from "react-avatar";
import { Tooltip } from "react-tooltip";
import Milestones from "./Milestones/Milestones";
import QuestionAndAnswer from "./QuestionAndAnswer/QuestionAndAnswer";
import { getBranchUser } from "../../../Services/userService";
import {
  getCustomerFields2,
  getCustomerFields,
} from "../../../Services/fieldsServices";
import Metrics from "./Metrics/Metrics";
import { getAddressList } from "../../../Services/addressService";
import ProgressSteps from "./ProgressSteps";
import PortfolioCards from "./PortfolioCards";
import { useOpportunity } from "../../../Providers/OpportunityContext";
import TabElement from "../../../Components/UiComponents/TabElement";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import { InputIcon } from "primereact/inputicon";
import ProjectTeam from "./ProjectTeam/ProjectTeam";
import { getUser, verifyToken } from "../../../Services/authService";
import { list } from "../../../Services/branchService";
import TeamChat from "./Chat/TeamChat";
import { getTemplate } from "../../../Services/customerServices";
import Loader from "../../../Components/UiComponents/Loader";
import socket from "../../../socket";
import { reThrowNotification, pendingNotifications } from "../../../Services/notificationService";
import { Menu } from "primereact/menu";
import useScrollToTop from "../../../Components/UiComponents/useScrollToTop";
import { useSidebar } from "../../../Providers/SidebarContext";
import Qualitative from "./Qualitative/Qualitative";

const PortfolioList = (props) => {
  const [items, setItems] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [customerId, setCustomerId] = useState(null);
  const [branch, setBranch] = useState(null);
  const [userId, setUserId] = useState(null);
  const childRef = useRef();
  const [element, setElements] = useState([]);
  const [count, setCount] = useState(0);
  const [projectSelectSections, setProjectSelectSections] = useState([]);
  const [pipelineRiskSections, setPipelineRiskSections] = useState([]);
  const { setIsEdited } = useIsEdited();
  const [pipelineTeamSections, setPipelineTeamSections] = useState([]);
  const [projectTeamTab, setProjectTeamTab] = useState([]);
  // const [clientFieldsNew, setClientFieldsNew] = useState([]);
  const [projectSelectFields, setProjectSelectFields] = useState([]);
  const [projectSumFields, setProjectSumFields] = useState([]);
  const [pipelineRiskFields, setPipelineRiskFields] = useState([]);
  const [oppRisksTable, setOppRisksTable] = useState([]);
  const [oppRiskIdentificationHeaders, setOppRiskIdentificationHeaders] =
    useState([]);
  const [oppProjectTeamHeaders, setOppProjectTeamHeaders] = useState([]);
  const [oppIdentificationHeaders, setOppIdentificationHeaders] = useState([]);
  const [oppRiskManagementHeaders, setOppRiskManagementHeaders] = useState([]);
  const { targetRef, scrollToTop } = useScrollToTop();
  const [oppManagementHeaders, setOppManagementHeaders] = useState([]);
  const [projectFieldsNew, setProjectFieldsNew] = useState([]);
  const [frameworkFieldsNew, setFrameworkFieldsNew] = useState([]);
  const [commanFieldsNew, setCommanFieldsNew] = useState([]);
  const [opportunityData, setOpportunityData] = useState({});
  const [prevBidLeaderId, setPrevBidLeaderId] = useState("");
  const [projectModules, setProjectModules] = useState([]);
  const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
  const [opportunityId, setOpportunityId] = useState(null);
  const [currStage, setCurrStage] = useState(null);
  const [stageIndex, setStageIndex] = useState(0);
  const [midStageIndex, setMidStageIndex] = useState(0);
  const [midStage, setMidStage] = useState(false);
  const [bidStatus, setBidStatus] = useState(null);
  const [bdStage, setBdStage] = useState(null);
  const [pqqStage, setPqqStage] = useState(null);
  const [ittStage, setIttStage] = useState(null);
  const [color, setColors] = useState(null);

  const location = useLocation();

  const [opportunityType, setOpportunityType] = useState([]);
  const [workType, setWorkType] = useState([]);
  const [goalType, setGoalType] = useState([]);
  const [goalQualitativeType, setGoalQualitativeType] = useState([]);
  const [logFrameGoalTarget, setLogFrameGoalTarget] = useState([]);
  const [procurementRoute, setProcurementRoute] = useState([]);
  const [sector, setSector] = useState([]);
  const [sectorStake, setSectorStake] = useState([]);
  const [clientMeetings, setClientMeetings] = useState([]);
  const [connectionsToProfessionalTeam, setConnectionsToProfessionalTeam] =
    useState([]);
  const [projectType, setProjectType] = useState([]);
  const [frameworkLength, setFrameworkLength] = useState([]);
  const [sourceOfOpportunity, setSourceOfOpportunity] = useState([]);
  const [formOfContract, setFormOfContract] = useState([]);
  const [formOfContract1, setFormOfContract1] = useState([]);
  const [tenderPeriod, setTenderPeriod] = useState([]);
  const [projectValue, setProjectValue] = useState([]);
  const [projectMargin, setProjectMargin] = useState([]);
  const [projectDuration, setProjectDuration] = useState([]);
  const [deliveryTeamRoles, setDeliveryTeamRoles] = useState([]);
  const [risks, setRisks] = useState([]);
  const [noOfCompetitors, setNoOfCompetitors] = useState([]);
  const [bondRequirement, setBondRequirement] = useState([]);
  const [bimRequirement, setBimRequirement] = useState([]);
  const [onerousTermsLADs, setOnerousTermsLADs] = useState([]);
  const [paymentTermsDays, setPaymentTermsDays] = useState([]);
  const [winnability, setWinnability] = useState([]);
  const [selectionWeightingFactors, setSelectionWeightingFactors] = useState(
    []
  );
  const [funding, setFunding] = useState([]);
  const [region, setRegion] = useState([]);
  const [businessUnit, setBusinessUnit] = useState([]);
  const [profitMorgin, setProfitMorgin] = useState([]);
  const [clientHistory, setClientHistory] = useState([]);
  const [depthOfClientEngagement, setDepthOfClientEngagement] = useState([]);
  const [clientClassification, setClientClassification] = useState([]);
  const [clientClassificationV1, setClientClassificationV1] = useState([]);
  const [clientClassificationV3, setClientClassificationV3] = useState([]);
  const [clientTypeV1, setClientTypeV1] = useState([]);
  const [clientType, setClientType] = useState([]);
  const [geography, setGeography] = useState([]);
  const [advisorHistory, setAdvisorHistory] = useState([]);
  const [depthOfAdvisorEngagement, setDepthOfAdvisorEngagement] = useState([]);
  const [resourcingTheBid, setResourcingTheBid] = useState([]);
  const [resourcingTheProject, setResourcingTheProject] = useState([]);
  const [workClassificationV2, setWorkClassificationV2] = useState([]);
  const [marginExpected, setMarginExpected] = useState([]);
  const [advisorType, setAdvisorType] = useState([]);
  const [organisationTypeV1, setOrganisationTypeV1] = useState([]);
  const [multiOrgType, setMultiOrgType] = useState([]);
  const [advisorClassification, setAdvisorClassification] = useState([]);
  const [fitWithBusinessPlan, setFitWithBusinessPlan] = useState([]);
  const [deliveryTeamAvailability, setDeliveryTeamAvailability] = useState([]);
  const [planningStatus, setPlanningStatus] = useState([]);
  const [otherRisks, setOtherRisks] = useState([]);
  const [riskManagement, setRiskManagement] = useState([]);
  const [bidTeamAvailability, setBidTeamAvailability] = useState([]);
  const [winPlanSection, setWinPlanSection] = useState([]);
  const [target, setTarget] = useState([]);
  const [bdLongShotRole, setBdLongShotRole] = useState([]);
  const [reviewHead, setReviewHead] = useState([[], [], [], [], [], [], []]);
  const [recommendedActions, setRecommendedActions] = useState([
    [],
    [],
    [],
    [],
    [],
    [],
  ]);
  const [midRecommendedActions, setMidRecommendedActions] = useState([[], []]);
  const [role, setRole] = useState([]);
  const [localAuthorities, setLocalAuthorities] = useState([]);
  const [winWorkStage, setWinWorkStage] = useState([]);
  const [services, setServices] = useState([]);
  const [subMainContractorBidStatus, setSubMainContractorBidStatus] = useState(
    []
  );
  const [isSubContract, setIsSubContract] = useState(false);
  const [riskType, setRiskType] = useState([]);
  const [riskCategory, setRiskCategory] = useState([]);
  const [profile, setProfile] = useState([]);
  const [submissionDocStatus, setSubmissionDocStatus] = useState([]);
  const [submissionDocStatusFilter, setSubmissionDocStatusFilter] = useState(
    []
  );
  const [breeam, setBreeam] = useState([]);
  const [unitOfMeasurement, setUnitOfMeasurement] = useState([]);
  const [attribution, setAttribution] = useState([]);
  const [score, setScore] = useState([]);
  const [data, setData] = useState([]);
  const [customerDetails, setCustomerDetails] = useState([]);
  const [lowestFactors, setLowestFactors] = useState([]);
  const [highestFactors, setHighestFactors] = useState([]);
  const [recomendendColumns, setRecomendendColumns] = useState([]);
  const [projectSumSections, setProjectSumSections] = useState([]);
  const [projectDetailsSections, setProjectDetailsSections] = useState([]);
  const [pipelineBidSections, setPipelineBidSections] = useState([]);
  const [projectDetailFields, setProjectDetailFields] = useState([]);
  const [clientFieldsNew, setClientFieldsNew] = useState([]);
  const [tableFieldsBidTeam, setTableFieldsBidTeam] = useState([]);
  const [internalTeamHeaders, setInternalTeamHeaders] = useState([]);
  const [externalTeamHeaders, setExternalTeamHeaders] = useState([]);
  const [pricingPlan, setPricingPlan] = useState("");
  const [tabPermissions, setTabPermissions] = useState({});
  const [sectionPermissions, setSectionPermissions] = useState({});
  const [restrictedUserTabs, setRestrictedUserTabs] = useState([]);
  const [appRestrictedTabs, setAppRestrictedTabs] = useState([]);
  const [enableTabs, setEnableTabs] = useState({});
  const [customerTooltipDataDetails, setCustomerTooltipDataDetails] = useState(
    {}
  );
  const [customerTooltipDataOthers, setCustomerTooltipDataOthers] = useState(
    {}
  );
  const [customerTooltipGateway, setCustomerTooltipGateway] = useState({});
  const [frameworkDetails, setFrameworkDetails] = useState([]);
  const [currency, setCurrency] = useState("");
  const [pipelinePlanSections, setPipelinePlanSections] = useState([]);
  const [pipelineWinningSections, setPipelineWinningSections] = useState([]);
  const [pipelineReviewSections, setPipelineReviewSections] = useState([]);
  const [pipelineGatewaysSections, setPipelineGatewaysSections] = useState([]);
  const [clientPlanFieldsNew, setClientPlanFieldsNew] = useState([]);
  const [clientPlan, setClientPlan] = useState({});
  const [clientPlanSectionNew, setClientPlanSectionNew] = useState([]);
  const [clientPlanTable, setClientPlanTable] = useState([]);
  const [oppClientPlanTable, setOppClientPlanTable] = useState([]);
  const [oppClientPlanDocHeaders, setOppClientPlanDocHeaders] = useState([]);
  const [oppClientPlanInitHeaders, setOppClientPlanInitHeaders] = useState([]);
  const [oppWaysOfWinningTable, setOppWaysOfWinningTable] = useState([]);
  const [oppWaysOfWinningHeaders, setOppWaysOfWinningHeaders] = useState([]);
  const [oppReviewsTable, setOppReviewsTable] = useState([]);
  const [oppReviewsCompletedHeaders, setoppReviewsCompletedHeaders] = useState(
    []
  );
  const [oppReviewsActionHeaders, setOppReviewsActionHeaders] = useState([]);
  const [oppReviewsApprovalHeaders, setOppReviewsApprovalHeaders] = useState(
    []
  );
  const [oppGatewaysTable, setOppGatewaysTable] = useState([]);
  const [oppGatewaysHeaders, setOppGatewaysHeaders] = useState([]);
  const [initiativeSelected, setInitiativeSelected] = useState("");
  const [shortName, setShortName] = useState("");
  const [currVersion, setCurrVersion] = useState("");
  const [versions, setVersions] = useState([]);
  const [projectStakeTabSections, setProjectStakeTabSections] = useState([]);
  const [pipelineStakeSections, setPipelineStakeSections] = useState([]);
  const [pipelineStakeFields, setPipelineStakeFields] = useState([]);
  const [oppStakeholdersTable, setOppStakeholdersTable] = useState([]);
  const [pipelineModules, setPipelineModule] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState();
  const [branchDetails, setBranchDetail] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [relationshipOwner, setRelationshipOwner] = useState([]);
  const [oppListStakeholdersHeaders, setOppListStakeholdersHeaders] = useState(
    []
  );
  const [oppIndiStakeholdersHeaders, setOppIndiStakeholdersHeaders] = useState(
    []
  );
  const [havingBranch, setHavingBranch] = useState(false);
  const [clientSectionsNew, setClientSectionsNew] = useState([]);
  const [orgFieldsNew, setOrgFieldsNew] = useState([]);
  const [customerTableData, setCustomerTableData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [pipelineSubSections, setPipelineSubSections] = useState([]);
  const [pipelineSubFields, setPipelineSubFields] = useState([]);
  const [oppSubmissionManagementTable, setOppSubmissionManagementTable] =
    useState([]);
  const [oppSubmissionManagementHeaders, setOppSubmissionManagementHeaders] =
    useState([]);
  const [submissionLabels, setSubmissionLabels] = useState({});
  const [projectMetricSections, setProjectMetricSections] = useState([]);
  const [projectMetricFields, setProjectMetricFields] = useState([]);
  const [pipelineClientsubmodule, setPipelineClientsubmodule] = useState([]);
  const [pipelineClientFields, setPipelineClientFields] = useState([]);
  const [pipelineLogFrameFields, setPipelineLogFrameFields] = useState([]);
  const [isWonOrLoss, setIsWonOrLoss] = useState(false);
  const [oppMetricsTable, setOppMetricsTable] = useState([]);
  const [oppMetricsHeaders, setOppMetricsHeaders] = useState([]);
  const [displayValues, setDisplayValues] = useState({});
  const [criticalheaders, setCriticalheaders] = useState([]);
  const [kpiheaders, setKpiheaders] = useState([]);
  const [fieldDetails, setFieldDetails] = useState([]);
  const [addressDetails, setAddressDetails] = useState([]);
  const [filterAddressDetails, setFilterAddressDetails] = useState([]);
  const [clientFieldsAC, setClientFieldsAC] = useState();
  const [clientSectionsAC, setClientSectionsAC] = useState({});
  const [clientACTab, setClientACTab] = useState();
  const [addressContactFields, setAddressContactFields] = useState();
  const [clientName, setClientName] = useState();
  const [clientDetails, setClientDetails] = useState();
  const [enableClienTypeDesc, setEnableClienTypeDesc] = useState(false);
  const [frameworkData, setFrameworkData] = useState({});
  const [customerTooltipSummary, setCustomerTooltipSummary] = useState({});
  const [pipelineStakesubmodule, setPipelineStakesubmodule] = useState([]);
  const [pipelineWinplanSections, setPipelineWinplanSections] = useState([]);
  const [oppWinPlanTable, setOppWinPlanTable] = useState([]);
  const [oppWinplanIdenHeaders, setOppWinplanIdenHeaders] = useState([]);
  const [oppWinplanManageHeaders, setOppWinplanManageHeaders] = useState([]);
  const [oppProjectTeamTable, setOppProjectTeamTable] = useState([]);
  const [oppClientTable, setOppClientTable] = useState([]);
  const [pipelineWinplansubmodule, setPipelineWinplansubmodule] = useState([]);
  const [pipelineWinplanFields, setPipelineWinplanFields] = useState([]);
  const [testSections, setTestSections] = useState([]);
  const [modelNew, setModalNew] = useState([]);
  const [planData, setPlanData] = useState([]);
  const [defaultData, setDefaultData] = useState([]);
  const [rdsScore, setRdsScore] = useState();
  const [colorRDSStatus, setColorRDSStatus] = useState({});
  const [planType, setPlanType] = useState([]);
  const [isStop, setIsStop] = useState(false);
  const [isSingleBox, setIsSingleBox] = useState(false);
  const [isMultiBox, setIsMultiBox] = useState(false);
  const [winScore, setWinScore] = useState({});
  const toastRef = useRef();
  const userRef = useRef();
  const [pipelineLogFrameSections, setPipelineLogFrameSections] = useState([]);
  const [pipelineLogFramesubmodule, setPipelineLogFramesubmodule] = useState(
    []
  );
  const [pipelineQualitativeHeader, setPipelineQualitativeHeader] = useState([]);

  const [userFilterReports, setUserFilterReports] = useState([]);
  const [internBidUserFilter, setInternBidUserFilter] = useState([]);
  const [oppTargetTable, setOppTargetTable] = useState([]);
  const [oppTargetHeaders, setOppTargetHeaders] = useState([]);
  const [customerTooltipRisks, setCustomerTooltipRisks] = useState({});
  const [oppQualitativeTable, setOppQualitativeTable] = useState([]);
  const [oppQualitativeHeaders, setOppQualitativeHeaders] = useState({});
  const [riskScores, setRiskScores] = useState({});
  const [riskColor, setRiskColor] = useState({});
  const [riskOppColor, setRiskOppColor] = useState({});
  const [pendingResponsibility, setPendingResponsibility] = useState([]);
  const [oppClientHeaders, setOppClientHeaders] = useState([]);
  const [pipelineClientSections, setPipelineClientSections] = useState([]);
  const [oppOthersTooltip, setOppOthersTooltip] = useState({});
  const [pipelineRisksubmodule, setPipelineRisksubmodule] = useState([]);
  const [newState, setNewState] = useState([]);
  const [individualScore, setIndividualScore] = useState([]);
  const [errors, setErrors] = useState([])
  const [tabName, setTabName] = useState([])
  const [activeComponent, setActiveComponent] = useState(null);
  const [activeTab, setActiveTab] = useState(null);
  const [open, setopen] = useState(true);
  const [newItems, setNewItems] = useState([]);
  const { globalSidebarData } = useSidebar();
  const [activeusers, setActiveUsers] = useState()
  const [currentUserId, setCurrentUserId] = useState();
  const navigate = useNavigate()

  const winstages = [
    { stage: "Target", elem: "#stage1" },
    { stage: "Pursuit", elem: "#stage2" },
    { stage: "Pre-Qualify", elem: "#stage3" },
    { stage: "Submission", elem: "#stage4" },
    { stage: "Appointment", elem: "#stage5" },
    { stage: "Deliver", elem: "#stage6" },
    { stage: "Feedback", elem: "#stage7" },
  ];

  useEffect(() => {
    setGlobalOpportunityData(opportunityData);
  }, [opportunityData]);

  var tmpPrivilegeenduser = localStorage.getItem("user_privileges");
  if (tmpPrivilegeenduser) {
    const tmpPrivilege = JSON.parse(tmpPrivilegeenduser);
    if (tmpPrivilege !== undefined && tmpPrivilege !== null) {
      var statusPrivilege = tmpPrivilege[0].bid_status_edit
    }
  }

  const checkOtherUsers = async () => {
    const user  = await getUser();
    const getOppAccessResponse = await getOppAccess(opportunityData._id, user.data.userid)
    if (getOppAccessResponse?.data?.user?.[0].userId){
      const otherUser = []
      for (let item in getOppAccessResponse?.data?.user){
        if (getOppAccessResponse.data.user[item].userId !== user.data.userid)
        {
          otherUser.push({
            "initial": `${getOppAccessResponse.data.user[item]?.firstname} ${getOppAccessResponse.data.user[item]?.lastname}`,
            "name": `${getOppAccessResponse.data.user[item]?.firstname} ${getOppAccessResponse.data.user[item]?.lastname}`
          })
        }
      }
      setActiveUsers(otherUser)
    }
  }

  const showToast = async (data) => {
    toastRef.current.showToast({
      type: "warn",
      // summary: "Action Required",
      message: (
        <div className="d-flex justify-content-between align-item-centermt-1">
          <span>
          {data?.firstname} {data?.lastname} updated the Project recently. Please{" "} 
  <a
    href="#"
    onClick={(e) => {
      e.preventDefault(); // Prevents default anchor behavior
      window.location.reload(); // Refreshes the page
    }}
    style={{
      color: "#007bff",
      textDecoration: "underline",
      cursor: "pointer",
    }}
  >
    Refresh
  </a>{" "} to incorporate changes</span>
        </div>
      ),
      sticky: true
    });
  }

  const initiateSocket = async () => {
    if (opportunityData?.customer_id){
      const user  = await getUser();
      userRef.current = user.data
      setCurrentUserId(user.data.userid);
      socket.emit("login", {browserId: user.data.uniqid, customer_id: opportunityData.customer_id})
      socket.emit("opportunityIn", {browserId: user.data.uniqid, customer_id: opportunityData.customer_id, oppId: opportunityData._id})
      socket.on("oppUpdate", async () => {await checkOtherUsers()})
      socket.on("oppDataUpdate", async (data) => {await showToast(data)})
    }
  }
  useEffect(() => {
    initiateSocket();
    checkOtherUsers();
  }, [opportunityData])

  useEffect(() => {
    if (data && data.length > 0) {
      data.forEach((item) => {
        const activeChoices = item.option_choice.filter(
          (choice) => choice.status === "active"
        );
        switch (item.option_names) {
          case "opportunityType":
            setOpportunityType(activeChoices);
            break;
          case "WorkType":
            setWorkType(activeChoices);
            break;
          case "logFrameGoal":
            setGoalType(
              activeChoices.map((choice) => ({
                label: choice.label,
                id: choice._id,
              }))
            );
            break;
          case "logFrameGoalQualitative":
            setGoalQualitativeType(
              activeChoices.map((choice) => ({
                label: choice.label,
                id: choice._id,
              }))
            );
            break
          case "logFrameTarget":
            setLogFrameGoalTarget(activeChoices);
            break;
          case "ProcurementRoute":
            setProcurementRoute(activeChoices);
            break;
          case "SectorV1":
            setSector(activeChoices);
            setSectorStake(
              activeChoices.map((element) => ({
                id: element._id,
                label: element.label,
                status: element.status,
              }))
            );
            break;
          case "ClientMeetings":
            setClientMeetings(activeChoices);
            break;
          case "ConnectionsToProfessionalTeam":
            setConnectionsToProfessionalTeam(activeChoices);
            break;
          case "ProjectType":
            setProjectType(activeChoices);
            break;
          case "FrameworkLength":
            setFrameworkLength(activeChoices);
            break;
          case "SourceOfOpportunity":
            setSourceOfOpportunity(activeChoices);
            break;
          case "FormOfContractV2":
            setFormOfContract(activeChoices);
            break;
          case "FormOfContractV1":
            setFormOfContract1(activeChoices);
            break;
          case "TenderPeriod":
            setTenderPeriod(activeChoices);
            break;
          case "ProjectValue":
            setProjectValue(activeChoices);
            break;
          case "ProjectMargin":
            setProjectMargin(activeChoices);
            break;
          case "ProjectDuration":
            setProjectDuration(activeChoices);
            break;
          case "DeliveryTeamRoles":
            setDeliveryTeamRoles(activeChoices);
            break;
          case "Risks":
            setRisks(activeChoices);
            break;
          case "NoOfCompetitorsV2":
            setNoOfCompetitors(activeChoices);
            break;
          case "BondRequirement":
            setBondRequirement(activeChoices);
            break;
          case "BimRequirement":
            setBimRequirement(activeChoices);
            break;
          case "onerousTermsLADs":
            setOnerousTermsLADs(activeChoices);
            break;
          case "PaymentTermsDays":
            setPaymentTermsDays(activeChoices);
            break;
          case "Winnability":
            setWinnability(activeChoices);
            break;
          case "SelectionweightingFactors":
            setSelectionWeightingFactors(activeChoices);
            break;
          case "Funding":
            setFunding(activeChoices);
            break;
          case "Region":
            setRegion(activeChoices);
            break;
          case "BusinessUnit":
            setBusinessUnit(activeChoices);
            break;
          case "ProfitMorgin":
            setProfitMorgin(activeChoices);
            break;
          case "ClientHistory":
            setClientHistory(activeChoices);
            break;
          case "DepthOfClientEngagement":
            setDepthOfClientEngagement(activeChoices);
            break;
          case "ClientClassificationV1":
            setClientClassificationV1(activeChoices);
            setClientClassification(
              activeChoices.map((element) => ({
                id: element._id,
                label: element.label,
                status: element.status,
              }))
            );
            break;
          case "ClientClassificationV3":
            setClientClassificationV3(activeChoices);
            break;
          case "clientTypeV1":
            setClientTypeV1(activeChoices);
            setClientType(
              activeChoices.map((element) => ({
                id: element._id,
                label: element.label,
                status: element.status,
              }))
            );
            break;
          case "Geography":
            setGeography(activeChoices);
            break;
          case "AdvisorHistory":
            setAdvisorHistory(activeChoices);
            break;
          case "DepthOfAdvisorEngagement":
            setDepthOfAdvisorEngagement(activeChoices);
            break;
          case "ResourcingTheBid":
            setResourcingTheBid(activeChoices);
            break;
          case "ResourcingTheProject":
            setResourcingTheProject(activeChoices);
            break;
          case "WorkClassificationV2":
            setWorkClassificationV2(activeChoices);
            break;
          case "MarginExpected":
            setMarginExpected(activeChoices);
            break;
          case "AdvisorType":
            setAdvisorType(activeChoices);
            break;
          case "OrganisationTypeV1":
            setOrganisationTypeV1(activeChoices);
            break;
          case "MultiOrgType":
            setMultiOrgType(activeChoices);
            break;
          case "AdvisorClassification":
            setAdvisorClassification(activeChoices);
            break;
          case "FitWithBusinessPlan":
            setFitWithBusinessPlan(activeChoices);
            break;
          case "DeliveryTeamAvailability":
            setDeliveryTeamAvailability(activeChoices);
            break;
          case "PlanningStatus":
            setPlanningStatus(activeChoices);
            break;
          case "OtherRisks":
            setOtherRisks(activeChoices);
            break;
          case "RiskManagement":
            setRiskManagement(activeChoices);
            break;
          case "BidTeamAvailability":
            setBidTeamAvailability(activeChoices);
            break;
          case "WinPlanSection":
            setWinPlanSection(activeChoices);
            break;
          case "Target":
            setTarget(activeChoices);
            break;
          case "BDLongShotRole":
            setBdLongShotRole(activeChoices);
            break;
          case "ReviewHead":
            const reviewHeadState = [...reviewHead];
            reviewHeadState[0] = activeChoices;
            setReviewHead(reviewHeadState);
            break;
          case "RecommendedActions":
            const recommendedActionsState = [...recommendedActions];
            recommendedActionsState[0] = activeChoices;
            setRecommendedActions(recommendedActionsState);
            break;
          case "MidRecommendedActions":
            const midRecommendedActionsState = [...midRecommendedActions];
            midRecommendedActionsState[0] = activeChoices;
            setMidRecommendedActions(midRecommendedActionsState);
            break;
          case "Role":
            setRole(activeChoices);
            break;
          case "LocalAuthorities":
            setLocalAuthorities(activeChoices);
            break;
          case "WinWorkStage":
            setWinWorkStage(activeChoices);
            break;
          case "Services":
            setServices(activeChoices);
            break;
          case "SubMainContractorBidStatus":
            setSubMainContractorBidStatus(activeChoices);
            break;
          case "RiskType":
            setRiskType(activeChoices);
            break;
          case "RiskCategory":
            setRiskCategory(activeChoices);
            break;
          case "Profile":
            setProfile(activeChoices);
            break;
          case "SubmissionDocStatus":
            setSubmissionDocStatus(activeChoices);
            break;
          case "SubmissionDocStatusFilter":
            setSubmissionDocStatusFilter(activeChoices);
            break;
          case "Breeam":
            setBreeam(activeChoices);
            break;
          case "UnitofMeasurement":
            setUnitOfMeasurement(activeChoices);
            break;
          case "Attribution":
            setAttribution(activeChoices);
            break;
          case "Score":
            setScore(activeChoices);
            break;
          default:
            break;
        }
      });
    }
  }, [data]);

  useEffect(() => {
    if (riskScores) {
      riskColors();
      riskOppColors();
    }
  }, [riskScores]);

  useEffect(() => {
    if (pricingPlan) {
      getPlanDetail();
    }
  }, [pricingPlan]);

  useEffect(() => {
    const regex = /\/portfolio\/([^\/]+)/;
    const match = location.pathname.match(regex);
    const id = match ? match[1] : null; 
    if (id) {
      setOpportunityId(id);
    }
  }, []);

  useEffect(() => {
    const customerData = localStorage.getItem("enduser");
    if (customerData) {
      const customerDataInJSON = JSON.parse(customerData);
      setCustomerId(customerDataInJSON.customer);
      setBranch(customerDataInJSON.branch);
      setUserId(customerDataInJSON.userid);
    } else {
      navigate("/login")
      localStorage.clear()
    }
  }, []);

  useEffect(() => {
    enablingTabs();
    getModulePermission();
  }, [appRestrictedTabs, restrictedUserTabs]);

  useEffect(() => {
    getBranchList()
  }, [branch]);

  useEffect(() => {
    if (customerId) {
      getFields();
      getTables();
      getCustomerDetails();
      getAllframeworks();
      getCustomerFieldDetails();
      getAddressDetails();
      getDefaultData()
    }
  }, [customerId]);

  useEffect(() => {
    if (versions) {
      getCurrentVersion();
    }
  }, [versions]);

  useEffect(() => {
    if ((opportunityId, userId)) {
      getOpportunities();
    }
  }, [opportunityId, userId]);

  useEffect(() => {
    if (!_.isEmpty(opportunityData)) {
      getClientDetails();
      getActionOwners();
      getBranchUsers();
    }
  }, [opportunityData]);

  useEffect(() => {
    if (data.length > 0 && testSections.length > 0) {
      getPlanData()
    } else if (data.length > 0 && testSections.length == 0 && !opportunityData.isTemplateAdded && defaultData.length > 0) {
      addDefaultTemplate(defaultData)
    }
  }, [data, testSections, opportunityData, defaultData]);

  useEffect(() => {
    socket.on('getBrowserId', async () => {
      const user = await getUser();
      if (user) {
        if (!_.isEmpty(user.data.uniqid)) {
          socket.emit('bindBrowserId', { browserId: user.data.uniqid, customer_id: user.data.customer });
        }
      }
    });
  }, []);

  const addDefaultTemplate = (defaultTemplate) => {
    var testData = [];
    if (testSections.length > 0) {
      for (var i = 0; i < defaultTemplate.length; i++) {
        var index = _.findIndex(testSections, {
          win_plan_name: defaultTemplate[i].win_plan_name,
        });
        if (index != -1) {
          for (var j = 0; j < defaultTemplate[i].theme.length; j++) {
            var themeIndex = _.findIndex(testSections[index].theme, {
              win_plan_theme: defaultTemplate[i].theme[j].win_plan_theme,
            });
            if (themeIndex == -1) {
              testSections[index].theme.push({
                checked: defaultTemplate[i].theme[j].checked,
                win_plan_theme: defaultTemplate[i].theme[j].win_plan_theme,
                win_plan_user: defaultTemplate[i].theme[j].win_plan_user,
              });
            }
          }
        } else {
          testSections.push({
            win_plan_name: defaultTemplate[i].win_plan_name,
            theme: defaultTemplate[i].theme,
          });
        }
      }
    } else {
      for (var i = 0; i < defaultTemplate.length; i++) {
        const winThemes = data.filter(
          (item) => item.display_name === defaultTemplate[i].win_plan_name
        );
        if (!_.isEmpty(winThemes)) {
          for (var j = 0; j < defaultTemplate[i].theme.length; j++) {
            defaultTemplate[i].theme[j].checked = false;
            var resLength = winThemes[0].option_choice.length;
            if (resLength > 0) {
              for (var m = 0; m < resLength; m++) {
                if (winThemes[0].option_choice[m].label == defaultTemplate[i].theme[j].win_plan_theme)
                  testData.push({
                    label: winThemes[0].option_choice[m].label,
                    id: winThemes[0].option_choice[m]._id,
                    winplan: winThemes[0].display_name,
                  });
              }
            }
          }
        }
      }
    }
    opportunityData.isTemplateAdded = true;
    setPlanData(testData)
    setTestSections(defaultTemplate)
    var modelNew = testData.slice(0);
    setModalNew(modelNew);
  }

  const getDefaultData = async () => {
    if (!opportunityData.isTemplateAdded) {
      var templateData = await getTemplate(customerId)
      if (templateData && templateData.data) {
        setDefaultData(templateData.data.win_plan_section)
      }
    }
  }

  const getPlanData = () => {
    if (data.length > 0 && testSections.length > 0) {
      var planData = [];
      for (var i = 0; i < testSections.length; i++) {
        const winThemes = data.filter(
          (item) => item.display_name === testSections[i].win_plan_name
        );

        if (!_.isEmpty(winThemes)) {
          for (var j = 0; j < testSections[i].theme.length; j++) {
            testSections[i].theme[j].checked = false;
            var resLength = winThemes[0].option_choice.length;
            if (resLength > 0) {
              for (var m = 0; m < resLength; m++) {
                if (
                  winThemes[0].option_choice[m].label ==
                  testSections[i].theme[j].win_plan_theme
                )
                  planData.push({
                    label: winThemes[0].option_choice[m].label,
                    id: winThemes[0].option_choice[m]._id,
                    winplan: winThemes[0].display_name,
                  });
              }
            }
          }
        }
      }
      setPlanData(planData);
      var modelNew = planData.slice(0);
      setModalNew(modelNew);
    }
  }

  const getModulePermission = async () => {
    try {
      if (pricingPlan) {
        const res = await getModulePermissions(pricingPlan, "Pipeline");

        if (res && res.data) {
          const modulePermissions = res.data;
          if (modulePermissions.status && modulePermissions.sub_modules) {
            var tabPermissions = {};
            _.filter(modulePermissions.sub_modules, (sub_module) => {
              tabPermissions[sub_module.module_name] = sub_module.status;
            });
            setTabPermissions(tabPermissions);
          }

          if (modulePermissions.status && modulePermissions.sections) {
            const sectionPermissions = {};
            _.filter(modulePermissions.sections, (section) => {
              sectionPermissions[section.section] = section.status;
            });
            setSectionPermissions(sectionPermissions);
          }
        }
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  const getTables = async () => {
    try {
      const response = await getTable(customerId);
      if (response && response.data) {
        const clientModuleData = response.data;
        if (clientModuleData) {
          var clientModules = _.find(clientModuleData.cust[0].modules, {
            module_name: "Clients",
            status: true,
          });
          var oppFieldsTable = _.find(clientModuleData.cust[0].modules, {
            module_name: "Pipeline",
            status: true,
          });

          var clientPlanTable = _.find(clientModules.sub_modules, {
            sub_module_name: "Client Plan",
          })?.tables;
          setClientPlanTable(clientPlanTable);

          var oppClientPlanTable = _.find(oppFieldsTable.sub_modules, {
            sub_module_name: "Client Plan",
          }).tables;
          setOppClientPlanTable(oppClientPlanTable);
          var oppClientPlanInitHeaders = _.find(oppClientPlanTable, {
            table_name: "Initiatives",
          }).headers;
          setOppClientPlanInitHeaders(oppClientPlanInitHeaders);
          var oppClientPlanDocHeaders = _.find(oppClientPlanTable, {
            table_name: "Document Reference",
          }).headers;
          setOppClientPlanDocHeaders(oppClientPlanDocHeaders);

          var oppWaysOfWinningTable = _.find(oppFieldsTable.sub_modules, {
            sub_module_name: "Ways of Winning",
          }).tables;
          setOppWaysOfWinningTable(oppWaysOfWinningTable);
          var oppWaysOfWinningHeaders = _.find(oppWaysOfWinningTable, {
            table_name: "Completed List",
          }).headers;
          setOppWaysOfWinningHeaders(oppWaysOfWinningHeaders);

          var oppReviewsTable = _.find(oppFieldsTable.sub_modules, {
            sub_module_name: "Reviews",
          }).tables;
          setOppReviewsTable(oppReviewsTable);
          var oppReviewsCompletedHeaders = _.find(oppReviewsTable, {
            table_name: "Completed List",
          }).headers;
          setoppReviewsCompletedHeaders(oppReviewsCompletedHeaders);
          var oppReviewsActionhHeaders = _.find(oppReviewsTable, {
            table_name: "Review Actions",
          }).headers;
          setOppReviewsActionHeaders(oppReviewsActionhHeaders);
          var oppReviewsApprovalHeaders = _.find(oppReviewsTable, {
            table_name: "Approvals",
          }).headers;
          setOppReviewsApprovalHeaders(oppReviewsApprovalHeaders);

          var oppGatewaysTable = _.find(oppFieldsTable.sub_modules, {
            sub_module_name: "Gateways",
          }).tables;
          setOppGatewaysTable(oppGatewaysTable);
          var oppGatewaysHeaders = _.find(oppGatewaysTable, {
            table_name: "Gateway Status",
          }).headers;
          setOppGatewaysHeaders(oppGatewaysHeaders);

          var pipelineStakeholdersTable = _.find(oppFieldsTable?.sub_modules, {
            sub_module_name: "Stakeholders",
          })?.tables;
          setOppStakeholdersTable(pipelineStakeholdersTable);
          var oppListStakeholdersHeaders = _.find(pipelineStakeholdersTable, {
            table_name: "List of Design Team Members",
          })?.headers;
          setOppListStakeholdersHeaders(oppListStakeholdersHeaders);

          var oppIndiStakeholdersHeaders = _.find(pipelineStakeholdersTable, {
            table_name: "Individual Stakeholder",
          })?.headers;
          setOppIndiStakeholdersHeaders(oppIndiStakeholdersHeaders);

          var oppBidTeamTable = _.find(oppFieldsTable.sub_modules, {
            sub_module_name: "Bid Team",
          }).tables;
          setTableFieldsBidTeam(oppBidTeamTable);

          var internalTeamHeaders = _.find(oppBidTeamTable, {
            table_name: "Internal Team List",
          })?.headers;
          setInternalTeamHeaders(internalTeamHeaders);
          var externalTeamHeaders = _.find(oppBidTeamTable, {
            table_name: "External Team List",
          })?.headers;
          setExternalTeamHeaders(externalTeamHeaders);

          var oppSubmissionManagementTable = _.find(oppFieldsTable.sub_modules, {
            sub_module_name: "Submission Management",
          }).tables;
          setOppSubmissionManagementTable(oppSubmissionManagementTable);
          var oppSubmissionManagementHeaders = _.find(
            oppSubmissionManagementTable,
            { table_name: "Document Response Management" }
          ).headers;
          setOppSubmissionManagementHeaders(oppSubmissionManagementHeaders);

          var oppMetricsTable = _.find(oppFieldsTable.sub_modules, {
            sub_module_name: "Metrics",
          }).tables;
          setOppMetricsTable(oppMetricsTable);
          var oppMetricsHeaders = _.find(oppMetricsTable, {
            table_name: "Building Performance",
          }).headers;
          setOppMetricsHeaders(oppMetricsHeaders);

          var oppWinPlanTable = _.find(oppFieldsTable.sub_modules, {
            sub_module_name: "Win Plan",
          }).tables;
          setOppWinPlanTable(oppWinPlanTable);
          var oppWinplanIdenHeaders = _.find(oppWinPlanTable, {
            table_name: "winPlan Identification",
          }).headers;
          setOppWinplanIdenHeaders(oppWinplanIdenHeaders);
          var oppWinplanManageHeaders = _.find(oppWinPlanTable, {
            table_name: "winPlan Management",
          }).headers;
          setOppWinplanManageHeaders(oppWinplanManageHeaders);

          var oppProjectTeamTable = _.find(oppFieldsTable.sub_modules, {
            sub_module_name: "Project Team",
          }).tables;
          setOppProjectTeamTable(oppProjectTeamTable);
          var oppClientTable = _.find(oppFieldsTable.sub_modules, {
            sub_module_name: "Client",
          }).tables;
          setOppClientTable(oppClientTable);
          var oppTargetTable = _.find(oppFieldsTable.sub_modules, {
            sub_module_name: "Target",
          }).tables;
          setOppTargetTable(oppTargetTable);
          var oppTargetHeaders = _.find(oppTargetTable, {
            table_name: "Goal",
          }).headers;
          setOppTargetHeaders(oppTargetHeaders);
          var oppQualitativeTable = _.find(oppFieldsTable.sub_modules, {
            sub_module_name: "Qualitative",
          }).tables;
          setOppQualitativeTable(oppQualitativeTable);
          var oppQualitativeHeaders = _.find(oppQualitativeTable, {
            table_name: "Goal",
          }).headers;
          setOppQualitativeHeaders(oppQualitativeHeaders);

          var oppFieldsTable = _.find(
            clientModuleData.cust[0].modules,
            { module_name: "Pipeline" },
            true
          );
          var oppRisksTable = _.find(oppFieldsTable.sub_modules, {
            sub_module_name: "Risks",
          }).tables;
          setOppRisksTable(oppRisksTable);
          var oppRiskIdentificationHeaders = _.find(oppRisksTable, {
            table_name: "Risk Identification",
          }).headers;
          var oppIdentificationHeaders = _.find(oppRisksTable, {
            table_name: "Opportunity Identification",
          }).headers;
          var oppRiskManagementHeaders = _.find(oppRisksTable, {
            table_name: "Risk Management",
          }).headers;
          var oppManagementHeaders = _.find(oppRisksTable, {
            table_name: "Opportunity Management",
          }).headers;
          setOppRiskManagementHeaders(oppRiskManagementHeaders);
          setOppManagementHeaders(oppManagementHeaders);
          setOppIdentificationHeaders(oppIdentificationHeaders);
          setOppRiskIdentificationHeaders(oppRiskIdentificationHeaders);

          var clientOppFieldsTable = _.find(oppFieldsTable.sub_modules, {
            sub_module_name: "Client",
          })?.tables;
          var oppClientHeaders = _.find(clientOppFieldsTable, {
            table_name: "Client's Organisation Stakeholders",
          })?.headers;
          setOppClientHeaders(oppClientHeaders);

          var oppProjectTeamHeaders = _.find(oppProjectTeamTable, {
            table_name: "Delivery Team",
          }).headers;
          setOppProjectTeamHeaders(oppProjectTeamHeaders);
        }
      }

    } catch (error) {
      console.error(error);
    }
  };

  const getFields = async () => {
    try {
      if (customerId != null) {
        const fieldsResponse = await getField(customerId);
        if (fieldsResponse && fieldsResponse.data) {
          setFieldDetails(fieldsResponse.data.cust[0].modules);
          var clientModules = _.find(fieldsResponse.data.cust[0].modules, {
            module_name: "Clients",
            status: true,
          });
          if (clientModules){
            setClientFieldsNew(
              _.find(clientModules.sub_modules, { sub_module_name: "NEW" }).fields
            );
            setClientSectionsNew(
              _.find(clientModules.sub_modules, { sub_module_name: "NEW" }).sections
            );

            // Address and Contact
            setClientFieldsAC(
              _.find(clientModules.sub_modules, {
                sub_module_name: "Address and Contact",
              }).fields
            );
            setClientSectionsAC(
              _.find(clientModules.sub_modules, {
                sub_module_name: "Address and Contact",
              }).sections
            );
            setClientACTab(
              _.find(clientModules.sub_modules, {
                sub_module_name: "Address and Contact",
              }).display_name
            );
          }

          //Contact
          var AddressContactModules = _.find(
            fieldsResponse.data.cust[0].modules,
            { module_name: "Address Book" },
            true
          );
          setAddressContactFields(
            _.find(AddressContactModules.sub_modules, {
              sub_module_name: "Contacts",
            }).fields
          );

          var orgModules = _.find(
            fieldsResponse.data.cust[0].modules,
            { module_name: "Organisations" },
            true
          );
          if (orgModules && orgModules.sub_modules) {
            var orgFieldsNew = _.find(orgModules?.sub_modules, {
              sub_module_name: "NEW",
            }).fields;
            setOrgFieldsNew(orgFieldsNew);
          }
          var projectModules = _.find(
            fieldsResponse.data.cust[0].modules,
            { module_name: "Pipeline" },
            true
          );
          var clientModules = _.find(
            fieldsResponse.data.cust[0].modules,
            { module_name: "Clients" },
            true
          );
          var clientFieldsNew = _.find(clientModules?.sub_modules, {
            sub_module_name: "NEW",
          })?.fields;
          setClientFieldsNew(clientFieldsNew);
          var clientPlanFieldsNew = _.find(clientModules.sub_modules, {
            sub_module_name: "Client Plan",
          }).fields;
          setClientPlanFieldsNew(clientPlanFieldsNew);

          setProjectModules(projectModules);
          // Framework
          var frameworkModules = _.find(
            fieldsResponse.data.cust[0].modules,
            { module_name: "Frameworks" },
            true
          );
          var frameworkFieldsNew = _.find(frameworkModules?.sub_modules, {
            sub_module_name: "NEW",
          })?.fields;
          setFrameworkFieldsNew(frameworkFieldsNew);

          //Comman Fields
          var commanModules = _.find(
            fieldsResponse.data.cust[0].modules,
            { module_name: "Common Fields" },
            true
          );
          var commanFieldsNew = _.find(commanModules.sub_modules, {
            sub_module_name: "Common Fields",
          }).fields;

          setCommanFieldsNew(commanFieldsNew);

          //SELECTIVITY
          var projectSelectFields = _.find(projectModules.sub_modules, {
            sub_module_name: "Selectivity",
          }).fields;
          setProjectSelectFields(projectSelectFields);
          var projectSelectSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Selectivity",
          }).sections;
          var pipelineRiskSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Risks",
          }).sections;
          setPipelineRiskSections(pipelineRiskSections);
          setProjectSelectSections(projectSelectSections);
          var projectSelectTab = _.find(projectModules.sub_modules, {
            sub_module_name: "Selectivity",
          }).display_name;
          var projectSumFields = _.find(projectModules.sub_modules, {
            sub_module_name: "Summary",
          }).fields;
          var pipelineRiskFields = _.find(projectModules.sub_modules, {
            sub_module_name: "Risks",
          }).fields;
          setPipelineRiskFields(pipelineRiskFields);
          setProjectSumFields(projectSumFields);
          var projectFieldsNew = _.find(projectModules.sub_modules, {
            sub_module_name: "NEW",
          }).fields;
          setProjectFieldsNew(projectFieldsNew);

          var projectSumSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Summary",
          }).sections;
          setProjectSumSections(projectSumSections);

          //Detail
          var projectDetailFields = _.find(projectModules.sub_modules, {
            sub_module_name: "Detail",
          }).fields;
          setProjectDetailFields(projectDetailFields);
          var projectDetailSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Detail",
          }).sections;
          setProjectDetailsSections(projectDetailSections);
          var projectDetailTab = _.find(projectModules.sub_modules, {
            sub_module_name: "Detail",
          }).display_name;
          var PipelineBidSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Bid Team",
          }).sections;
          setPipelineBidSections(PipelineBidSections);

          var pipelineReviewSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Reviews",
          }).sections;
          setPipelineReviewSections(pipelineReviewSections);

          var pipelinePlanSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Client Plan",
          }).sections;
          setPipelinePlanSections(pipelinePlanSections);

          //Geteways
          var pipelineGatewaysSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Gateways",
          }).sections;
          setPipelineGatewaysSections(pipelineGatewaysSections);

          //ways of winning
          var pipelineWinningSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Ways of Winning",
          }).sections;
          setPipelineWinningSections(pipelineWinningSections);

          var projectStakeTabSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Stakeholders",
          }).sections;
          setProjectStakeTabSections(projectStakeTabSections);
          var pipelineStakesubmodule = _.find(projectModules.sub_modules, {
            sub_module_name: "Stakeholders",
          }).display_name;
          setPipelineStakesubmodule(pipelineStakesubmodule);

          var pipelineStakeSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Add new Stakeholder",
          }).sections;
          setPipelineStakeSections(pipelineStakeSections);

          var pipelineStakeFields = _.find(projectModules.sub_modules, {
            sub_module_name: "Add new Stakeholder",
          }).fields;
          setPipelineStakeFields(pipelineStakeFields);

          //Submission management
          var pipelineSubSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Submission Management",
          }).sections;
          setPipelineSubSections(pipelineSubSections);

          var pipelineSubFields = _.find(projectModules.sub_modules, {
            sub_module_name: "Submission Management",
          }).fields;
          setPipelineSubFields(pipelineSubFields);

          var PQQLabel = _.find(pipelineSubFields, {
            field_name: "PQQ",
          }).display_name;
          var ITTLabel = _.find(pipelineSubFields, {
            field_name: "ITT",
          }).display_name;
          setSubmissionLabels({
            PQQLabel: PQQLabel,
            ITTLabel: ITTLabel,
          });

          //Metrics
          var projectMetricFields = _.find(projectModules.sub_modules, {
            sub_module_name: "Metrics",
          }).fields;
          setProjectMetricFields(projectMetricFields);
          var projectMetricSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Metrics",
          }).sections;
          setProjectMetricSections(projectMetricSections);
          var pipelineClientsubmodule = _.find(projectModules.sub_modules, {
            sub_module_name: "Client",
          }).display_name;
          setPipelineClientsubmodule(pipelineClientsubmodule);

          var pipelineLogFrameFields = _.find(projectModules.sub_modules, {
            sub_module_name: "Targets",
          }).fields;
          setPipelineLogFrameFields(pipelineLogFrameFields);
          var pipelineClientFields = _.find(projectModules.sub_modules, {
            sub_module_name: "Client",
          }).fields;
          setPipelineClientFields(pipelineClientFields);

          var pipelineWinplanSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Winplan",
          }).sections;
          setPipelineWinplanSections(pipelineWinplanSections);
          var pipelineWinplansubmodule = _.find(projectModules.sub_modules, {
            sub_module_name: "Winplan",
          }).display_name;
          setPipelineWinplansubmodule(pipelineWinplansubmodule);
          var pipelineWinplanFields = _.find(projectModules.sub_modules, {
            sub_module_name: "Winplan",
          }).fields;
          setPipelineWinplanFields(pipelineWinplanFields);

          // Win Score
          var winScoreBox = {};
          winScoreBox.sustainScore = _.find(projectFieldsNew, {
            field_name: "Sustainability Score",
          }).display_name;
          winScoreBox.riskScore = _.find(projectFieldsNew, {
            field_name: "Risk Score",
          }).display_name;
          winScoreBox.ESGScore = _.find(projectFieldsNew, {
            field_name: "ESG Preview Score",
          }).display_name;
          winScoreBox.opportunityScore = _.find(projectFieldsNew, {
            field_name: "Opportunity Score",
          }).display_name;
          setWinScore(winScoreBox);

          //Target
          var pipelineLogFrameSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Targets",
          }).sections;
          setPipelineLogFrameSections(pipelineLogFrameSections);
          var pipelineLogFramesubmodule = _.find(projectModules.sub_modules, {
            sub_module_name: "Targets",
          }).display_name;
          setPipelineLogFramesubmodule(pipelineLogFramesubmodule);

          //Qualitative
          var pipelineLogFrameSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Qualitative",
          })?.sections;
          var pipelineQualitativeHeader = _.find(projectModules.sub_modules, {
            sub_module_name: "Qualitative",
          })?.display_name;
          setPipelineQualitativeHeader(pipelineQualitativeHeader);

          var pipelineTeamSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Project Team",
          })?.sections;
          setPipelineTeamSections(pipelineTeamSections);
          var projectTeamTab = _.find(projectModules.sub_modules, {
            sub_module_name: "Project Team",
          })?.display_name;
          setProjectTeamTab(projectTeamTab);
          var pipelineClientSections = _.find(projectModules.sub_modules, {
            sub_module_name: "Client",
          })?.sections;
          setPipelineClientSections(pipelineClientSections);

          var pipelineRisksubmodule = _.find(projectModules.sub_modules, {
            sub_module_name: "Risks",
          })?.display_name;
          setPipelineRisksubmodule(pipelineRisksubmodule);
        }
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  const getAddressDetails = async function () {

    try {
      if (customerId === null) {
        return;
      }
      setLoading(true);
      if (customerId && opportunityData?.client_id) {
        let data = {
          limit: 10,
          skip: 0,
          searchByAddress: "",
        };
        const customerDAta = await getAddressList(
          opportunityData?.client_id,
          customerId,
          data.skip,
          data.limit,
          data.searchByAddress
        );
        setAddressDetails(customerDAta.data.address);
        setFilterAddressDetails(customerDAta.data.address);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  const getActionOwners = () => {
    var actionOwners = [];
    var internBidTeamUsers = [];
    if (!_.isUndefined(opportunityData.ie_bid_team)) {
      if (!_.isUndefined(opportunityData.ie_bid_team.internal_bid_team)) {
        for (
          var i = 0;
          i < opportunityData.ie_bid_team.internal_bid_team.length;
          i++
        ) {
          actionOwners.push({
            user_id: opportunityData.ie_bid_team.internal_bid_team[i].user_id,
            team_member:
              opportunityData.ie_bid_team.internal_bid_team[i].team_member,
            email_id: opportunityData.ie_bid_team.internal_bid_team[i].email,
          });
          internBidTeamUsers.push({
            user_id: opportunityData.ie_bid_team.internal_bid_team[i].user_id,
            team_member:
              opportunityData.ie_bid_team.internal_bid_team[i].team_member,
            email_id: opportunityData.ie_bid_team.internal_bid_team[i].email,
          });
        }
      }
      if (opportunityData.ie_bid_team.internal_bid_team) {
      }
      if (!_.isUndefined(opportunityData.ie_bid_team.external_bid_team)) {
        for (
          var j = 0;
          j < opportunityData.ie_bid_team.external_bid_team.length;
          j++
        ) {
          actionOwners.push({
            user_id: opportunityData.ie_bid_team.external_bid_team[j]._id,
            team_member:
              opportunityData.ie_bid_team.external_bid_team[j]
                .external_organisation,
            email_id: opportunityData.ie_bid_team.external_bid_team[j].email,
          });
        }
      }

      //For multi filters
      var actionOwnersFilter = [];
      var internBidUserFilter = [];
      _.filter(actionOwners, function (ao) {
        actionOwnersFilter.push({
          _id: ao.user_id,
          label: ao.team_member,
          email_id: ao.email_id,
        });
      });
      _.filter(internBidTeamUsers, function (ao) {
        internBidUserFilter.push({
          _id: ao.user_id,
          label: ao.team_member,
          email_id: ao.email_id,
        });
      });
      var userFilterReport = [];
      userFilterReport = actionOwnersFilter;
      setUserFilterReports(userFilterReport);
      setInternBidUserFilter(internBidUserFilter);
    }
  };

  const getClientDetails = async () => {
    var initiativeSelected = "";
    var tmpBranch = { branch_id: opportunityData.branch_id, branch_key: "sub" };

    try {
      if (customerId === null) {
        return;
      }
      var res = await getClients(
        opportunityData.client_id,
        customerId,
        tmpBranch
      );

      if (res && res.data.client && res.data.client[0]) {
        var clientPlan = res.data.client[0].client_plan;
        setClientName(res.data.client[0].client_name);
        setClientPlan(clientPlan);

        setClientDetails(res.data.client[0]);

        var rds_score = res.data.client[0].rds.rds_score;
        setRdsScore(res.data.client[0].rds.rds_score.toFixed(2));

        var customStyle = "";
        var customStyle2 = "";
        var colorStatus = "";

        if (rds_score <= 33) {
          customStyle = "background-red";
          customStyle2 = "color_red";
          colorStatus = "Weak";
        } else if (rds_score > 33 && rds_score <= 66) {
          customStyle = "background-amber";
          customStyle2 = "color_amber";
          colorStatus = "Moderate";
        } else if (rds_score > 66) {
          customStyle = "background-green";
          customStyle2 = "color_green";
          colorStatus = "Strong";
        }

        setColorRDSStatus({
          customStyle: customStyle,
          customStyle2: customStyle2,
          colorStatus: colorStatus,
        });

        var clientPlanSectionNew = res.data.client[0].client_plan_section_new;
        var noOfInitiatives = 0;
        if (clientPlanSectionNew.length > 0) {
          const updatedData = await Promise.all(
            clientPlanSectionNew.map(async (item) => {
              const initiatives = await Promise.all(
                item.strategic_initiative.map(async (cliData) => {
                  try {
                    const user = await getUser(cliData.person_responsible);
                    if (user) {
                      return {
                        ...cliData,
                        responsible_user: `${user.data.firstname} ${user.data.surname}`,
                      };
                    }
                  } catch (error) {
                    console.error("Error fetching user data:", error);
                    return cliData; // Return the original data if the fetch fails
                  }
                })
              );

              noOfInitiatives += initiatives.length; // Increment the initiatives count

              return {
                ...item,
                strategic_initiative: initiatives,
              };
            })
          );
          setClientPlanSectionNew(updatedData);
          if (noOfInitiatives > 1) {
            initiativeSelected = noOfInitiatives + " Checked";
          } else {
            initiativeSelected =
              clientPlanSectionNew[0].strategic_initiative[0]
                .strategic_initiative_name;
          }
          setInitiativeSelected(initiativeSelected);
        }
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };
  function generateRandomID() {
    const hexChars = "0123456789abcdef";
    let result = "";
    for (let i = 0; i < 24; i++) {
      result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
    }
    return result;
  }
  // Function to generate a random ID that is not equal to _id
  function generateUniqueRandomID(item) {
    let newID = generateRandomID();
    // Regenerate ID if it matches the existing _id
    while (newID === item._id) {
      newID = generateRandomID();
    }
    return newID;
  }
  const getOpportunities = async () => {
    try {
      const opportunityResponse = await get(
        opportunityId,
        customerId,
        branch,
        userId
      );
      if (opportunityResponse && opportunityResponse.data) {
        const opportunityData = opportunityResponse.data.opportunity[0];
        setPrevBidLeaderId(opportunityResponse.data.opportunity[0].bid_Leader_id);
        const updatedIdentificationInOpportunityData = {
          ...opportunityData, // Keep the rest of the opportunityData unchanged
          opportunity_identification: opportunityData.opportunity_identification.map(item => ({
            ...item,
            id: generateUniqueRandomID(item) // Add unique random ID that does not equal _id
          }))
        };

        setOpportunityData(updatedIdentificationInOpportunityData);

        var clientType = opportunityData.additional.client_type;
        if (!_.isUndefined(clientType)) {
          if (clientType == "Other (Specify)") {
            setEnableClienTypeDesc(true);
          } else {
            setEnableClienTypeDesc(false);
          }
        }

        let framework;
        if (!_.isUndefined(opportunityData.opportunity)) {
          if (!_.isUndefined(opportunityData.opportunity.framework)) {
            framework = {
              _id: opportunityData.opportunity.framework,
              framework_name: opportunityData.opportunity.framework_name,
              framework_display_name: opportunityData.opportunity.framework_name,
            };
          } else framework = "";
        } else {
          framework = "";
        }

        setFrameworkData(framework);

        var stageIndex = 0;
        if (opportunityData.winwork_stage == "Target") {
          stageIndex = 0;
        } else if (opportunityData.winwork_stage == "Pursuit") {
          stageIndex = 1;
        } else if (opportunityData.winwork_stage == "Pre-Qualify") {
          stageIndex = 2;
        } else if (opportunityData.winwork_stage == "Submission") {
          stageIndex = 3;
        } else if (opportunityData.winwork_stage == "Appointment") {
          stageIndex = 4;
        } else if (opportunityData.winwork_stage == "Deliver") {
          stageIndex = 5;
        } else {
          stageIndex = 6;
        }
        setStageIndex(stageIndex);

        var midStageIndex = 0;
        if (opportunityData.winwork_stage == "Submission") {
          midStageIndex = 0;
        } else if (opportunityData.winwork_stage == "Deliver") {
          midStageIndex = 1;
        } else {
          midStageIndex = 0;
        }
        setMidStageIndex(midStageIndex);

        if (
          opportunityData.winwork_stage == "Submission" ||
          opportunityData.winwork_stage == "Deliver"
        )
          setMidStage(true);

        setCurrStage(opportunityData.winwork_stage);
        setBidStatus(opportunityData.bid_status);

        if (opportunityData.bid_status == "Stop") {
          setIsStop(true);
        } else {
          setIsStop(false);
          if (
            opportunityData.bid_status == "Won" ||
            opportunityData.bid_status == "Lost"
          ) {
            setIsWonOrLoss(true);
          } else {
            setIsWonOrLoss(false);
          }
        }

        var displayValues = opportunityData.metrics.displayValues;
        var displayValues2 = [];
        if (opportunityData.metrics.displayValues2.length == 0) {
          displayValues2 = [
            { checked: false, areas: "Target", breeam: "", epc: "" },
            { checked: false, areas: "Proposed", breeam: "", epc: "" },
            {
              checked: false,
              areas: "Build Variations",
              breeam: "",
              epc: "",
            },
            { checked: false, areas: "Achieved", breeam: "", epc: "" },
          ];
        } else {
          displayValues2 = opportunityData.metrics.displayValues2;
        }
        var displayValues3 = opportunityData.metrics.displayValues3;
        setDisplayValues({
          displayValues: displayValues,
          displayValues2: displayValues2,
          displayValues3: displayValues3,
        });

        var critical_headers = [];
        if (_.isEmpty(opportunityData.metrics.critical_headers)) {
          critical_headers = [
            { header: "" },
            { header: "" },
            { header: "" },
            { header: "" },
            { header: "" },
          ];
        } else {
          critical_headers = opportunityData.metrics.critical_headers;
        }
        setCriticalheaders(critical_headers);

        var kpi_headers = [];
        if (_.isEmpty(opportunityData.metrics.kpi_headers)) {
          kpi_headers = [
            { header: "" },
            { header: "" },
            { header: "" },
            { header: "" },
            { header: "" },
          ];
        } else {
          kpi_headers = opportunityData.metrics.kpi_headers;
        }
        setKpiheaders(kpi_headers);

        var testSections = opportunityData.win_plan_section_new.slice(0);
        setTestSections(testSections);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAllframeworks = async () => {
    try {
      if (customerId === null) {
        return;
      }
      const res = await all(customerId, "analytic", "framework_name", 1);
      setFrameworkDetails(res.data);
    } catch (error) {
      // toastRef.current.showToast({
      //   type: 'error',
      //   message: 'An error occurred. Please try again or Contact Admin.'
      // });
      console.log(error)
    }
  };

  const getCustomerDetails = async () => {
    try {
      if (customerId === null) {
        return;
      }
      var customerDataResponse = await getCustomer(customerId);
      if (customerDataResponse && customerDataResponse.data) {
        var custData = customerDataResponse.data.reference_data;
        const bdStage = getStages(custData, "BD/Long Shot");
        const pqqStage = getStages(custData, "PQQ");
        const ittStage = getStages(custData, "ITT");
        setBdStage(bdStage);
        setPqqStage(pqqStage);
        setIttStage(ittStage);
        setData(custData);
        setCustomerDetails(customerDataResponse.data);
        setPricingPlan(customerDataResponse.data.pricing_plan);
        setAppRestrictedTabs(customerDataResponse.data.application_pipeline_tabs);
        setRestrictedUserTabs(customerDataResponse.data.restricted_pipeline_tabs);
        setCustomerTooltipDataDetails(
          customerDataResponse.data?.tooltips?.pipeline?.detail
        );
        setCustomerTooltipDataOthers(
          customerDataResponse.data?.tooltips?.pipeline?.others
        );
        setCustomerTooltipSummary(
          customerDataResponse.data?.tooltips?.pipeline?.summary
        );
        setCustomerTooltipGateway(
          customerDataResponse.data?.tooltips?.pipeline?.gateways
        );
        setCustomerTooltipRisks(
          customerDataResponse.data?.tooltips?.pipeline?.risks
        );
        setOppOthersTooltip(customerDataResponse.data?.tooltips?.pipeline?.others);
        setCurrency(
          !_.isUndefined(customerDataResponse.data.currency)
            ? customerDataResponse.data.currency
            : "£"
        );
        setShortName(customerDataResponse.data.customer_short);

        let versions = [];

        for (
          let i = 0;
          i < customerDataResponse.data.version_maintained.length;
          i++
        ) {
          if (
            customerDataResponse.data.version_maintained[i].module_name === "Client"
          ) {
            versions =
              customerDataResponse.data.version_maintained[i].version_detail;
            break;
          }
        }
        setVersions(versions);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  const getCurrentVersion = () => {
    const ver = versions;
    const found = ver.filter((version) => version.checked === true);
    if (found.length > 0) {
      setCurrVersion(found[0].folder);
    }
  };

  const getBranchUsers = async () => {
    if (customerId !== null && opportunityData) {
      try {
        // Fetch customer data from the server
        setLoading(true);
        const customerDataResponse = await getBranchUser(
          customerId,
          opportunityData.branch_id
        );
        if (customerDataResponse && customerDataResponse.data) {
          setLoading(false);
          setBranchDetail(customerDataResponse.data);
          var relation = customerDataResponse.data.map((o) => ({
            _id: o._id,
            label: o.firstname + " " + o.surname,
            status: o.status,
          }));
          setRelationshipOwner(relation);
        }

      } catch (error) {
        console.error("Error fetching branch fields:", error);
      }
    }
  };

  const getBranchList = async () => {
    // Ensure customerId is not null
    if (customerId !== null) {

      try {
        // Fetch customer data from the server
        setLoading(true)
        const customerDataResponse = await list(customerId, 'branch_name', -1);
        if (customerDataResponse && customerDataResponse.data) {
          setLoading(false)
          setBranchData(customerDataResponse?.data?.branch)
        }
      } catch (error) {
        // Log and notify if there's an error fetching customer data
        console.error("Error fetching branch fields:", error);
      }
    }
  };

  const getCustomerFieldDetails = async () => {
    if (customerId !== null) {
      try {
        setLoading(true);
        const customerData = await getCustomerFields2(customerId);
        if (customerData && customerData.data) {
          setLoading(false);
          setCustomerTableData(customerData?.data?.cust[0]?.modules);
          let Stakeholder = _.find(customerData?.data?.cust[0]?.modules, {
            module_name: "Clients",
          }).sub_modules;
          if (Stakeholder) {
            let clientFiltersNew = _.find(Stakeholder, {
              sub_module_name: "NEW",
            }).filters;
            setFilterData(clientFiltersNew);
          }
        }

      } catch (error) {
        console.error("Error fetching customer data", error);
      }
    }
    if (customerId !== null) {
      try {
        setLoading(true);
        const customerData = await getCustomerFields(customerId); // Reference
        if (customerData && customerData.data) {
          setLoading(false);
          setHavingBranch(customerData.data.havingBranch);
        }

      } catch (error) {
        console.error("Error fetching customer data", error);
      }
    }
  };

  // const elementUpdate = (data) => {
  //   setElements(data);
  // };

  // const resetStates = () => {
  //   setCount(0);
  //   setElements({});
  // };

  // useEffect(() => {
  //   if (element != null && !_.isEmpty(element) && count <= 6) {
  //     var newcount = count + 1
  //     setCount(newcount);
  //     if (newcount === 7) {
  //       resetStates()
  //     } else if (newcount <= 6) {
  //       if (bdStage && pqqStage && ittStage) {
  //         computeScore(0, "opportunityType");
  //       }
  //     }
  //   }
  // }, [element, count]);

  useEffect(() => {
    const colorSet = setColor(currStage, opportunityData.win_score, bidStatus);
    setColors(colorSet);
  }, [opportunityData, currStage, bidStatus])

  const globalOpportunityDataRef = useRef(null);
  useEffect(() => {
    globalOpportunityDataRef.current = globalOpportunityData
  }, [globalOpportunityData])

  const scoreCalculation = (data, pickedElem, previousValue, selectedOne, newAndSelectivityList) => {
    var individual_score = [];
    var recommendations = globalOpportunityDataRef.current?.globalFactors?.recommendations ? globalOpportunityDataRef.current.globalFactors.recommendations: [];
    var lowest_factors = [];
    var highest_factors = [];
    var score = 0;
    var previousScore = 0;
    // console.log("score calculation : ", data, pickedElem, previousValue, selectedOne, newAndSelectivityList)


    const selectedOptionLabel = data?.option_choice?.map((item) => item.label)
    recommendations = recommendations.filter((item) => !selectedOptionLabel.includes(item.label))

    

    if (data.option_names === pickedElem) {
      if (selectedOne) {
        if (!_.isEmpty(previousValue) || previousValue !== undefined) {
          previousScore = previousScore + previousValue.score * data.weightage;
        } else {
          previousScore = 0;
        }
        score = score + (selectedOne.score * data.weightage) - previousScore;
        var score_data = {
          text: selectedOne.label,
          score: score,
        };
      }

      var score_present = false;
      for (var i = 0; i < individual_score.length; i++) {
        if (individual_score[i]?.text == score_data?.text) {
          score_present = true;
          break;
        }
      }
      if (!score_present) {
        individual_score.push(score_data);
      }

      var display_name = _.find(newAndSelectivityList, {
        reference_key: data.option_names,
      })?.display_name;

      if (selectedOne?.text) {
        recommendations.push({
          label: selectedOne.label,
          score: selectedOne.score * data.weightage,
          factor_text: selectedOne.text,
        });
        lowest_factors.push({ factor_text: display_name });
      } else {
        if (selectedOne?.score > 2) {
          highest_factors.push({
            factor_text: display_name,
          });
        }
      }
    }

    var highest = highest_factors.length > 0 ? highest_factors[0] : null;
    var lowest = lowest_factors.length > 0 ? lowest_factors[0] : null;
    


    const objectExists = (arr, obj) => arr.some(item => item.factor_text === obj.factor_text);

    setGlobalOpportunityData((prevData) => ({
      ...prevData,
      win_score: prevData.win_score + score, // No need for ["win_score"]
      globalFactors: {
        highest_factors: highest
          ? objectExists(prevData.globalFactors?.highest_factors, highest)
            ? prevData.globalFactors?.highest_factors
            : [...prevData.globalFactors?.highest_factors, highest]
          : prevData.globalFactors?.highest_factors,
    
        lowest_factors: lowest
          ? objectExists(prevData.globalFactors?.lowest_factors, lowest)
            ? prevData.globalFactors?.lowest_factors
            : [...prevData.globalFactors?.lowest_factors, lowest]
          : prevData.globalFactors?.lowest_factors,
    
        recommendations: recommendations
      }
    }));
    
    setIndividualScore(individual_score)
    const colorSet = setColor(currStage, globalOpportunityData.win_score + score, bidStatus);
    setColors(colorSet);
  }

  const computeScore = async (index, pickedElem, selectedOne, previousValue) => {
    var newAndSelectivityList = projectSelectFields.concat(
      projectFieldsNew,
      clientFieldsNew,
      projectSumFields,
      projectDetailFields,
      pipelineClientFields,
      pipelineStakeFields,
      pipelineLogFrameFields
    );

    if (bidStatus != "Stop") {
      if (bdStage && pqqStage && ittStage) {
        bdStage.forEach((data, index) => {
          if (data.option_names === pickedElem) {
            scoreCalculation(data, pickedElem, previousValue, selectedOne, newAndSelectivityList)
          }
        })
        pqqStage.forEach((data, index) => {
          if (data.option_names === pickedElem) {
            scoreCalculation(data, pickedElem, previousValue, selectedOne, newAndSelectivityList)
          }
        });
        ittStage.forEach((data, index) => {
          if (data.option_names === pickedElem) {
            scoreCalculation(data, pickedElem, previousValue, selectedOne, newAndSelectivityList)
          }
        });
      }
    }
  }

  // const computeScore = async (index, pickedElem) => {
  //   setLoading(true)
  //   var newAndSelectivityList = projectSelectFields.concat(
  //     projectFieldsNew,
  //     clientFieldsNew,
  //     projectSumFields,
  //     projectDetailFields,
  //     pipelineClientFields,
  //     pipelineStakeFields,
  //     pipelineLogFrameFields
  //   );
  //   var elemIndex = index ? index : 0;
  //   var recommendations = [];
  //   var lowest_factors = [];
  //   var highest_factors = [];
  //   if (bidStatus != "Stop") {
  //     var individual_score = [];
  //     if (currStage === "Target1" || currStage === "Pursuit1") {
  //       setLoading(true)
  //       var score = 0;
  //       bdStage.forEach((data, index) => {
  //         var e = Object.keys(element).find((key) => key === data.option_names);
  //         if (e) {
  //           var selector = element[e]?.props?.value?.label;
  //           if (selector) {
  //             var elem = getElementFrom(bdStage, data.option_names);
  //             var selected = getScore(elem, selector);
  //             if (selected) {
  //               score = score + selected.score * data.weightage;
  //               var score_data = {
  //                 text: selected.label,
  //                 score: score,
  //               };
  //             }

  //             var score_present = false;
  //             for (var i = 0; i < individual_score.length; i++) {
  //               if (individual_score[i].text == score_data.text) {
  //                 score_present = true;
  //                 break;
  //               }
  //             }
  //             if (!score_present) {
  //               individual_score.push(score_data);
  //             }
  //             var display_name = _.find(projectSelectFields, {
  //               field_name: data.display_name,
  //             }).display_name;

  //             if (selected.text) {
  //               //lowest
  //               recommendations.push({
  //                 score: selected.score * data.weightage,
  //                 text: selected.text,
  //               });
  //               lowest_factors.push({ factor_text: display_name });
  //             } else {
  //               //highest
  //               if (selected.score > 2) {
  //                 highest_factors.push({
  //                   factor_text: display_name,
  //                 });
  //               }
  //             }
  //           }
  //         }
  //       });
  //       setGlobalFactorsData({
  //         ...globalFactorsData,
  //         highest_factors: highest_factors,
  //         lowest_factors: lowest_factors,
  //         recommendations: recommendations
  //       });
  //       setHighestFactors(highest_factors);
  //       setLowestFactors(lowest_factors);
  //       setRecomendendColumns(recommendations);
  //       setGlobalOpportunityData((prevData) => ({
  //         ...prevData,
  //         ["win_score"]: score,
  //       }));
  //       const colorSet = setColor(currStage, score, bidStatus);
  //       setColors(colorSet);
  //       setLoading(false)
  //     } else if (currStage === "Pre-Qualify1") {
  //       setLoading(true)
  //       var score = 0;
  //       bdStage.forEach((data, index) => {
  //         var e = Object.keys(element).find((key) => key === data.option_names);
  //         if (e) {
  //           var selector = element[e]?.props?.value?.label;
  //           if (selector) {
  //             var elem = getElementFrom(bdStage, data.option_names);
  //             var selected = getScore(elem, selector);
  //             score = score + selected.score * data.weightage;
  //             var score_data = {
  //               text: selected.label,
  //               score: score,
  //             };
  //             var score_present = false;
  //             for (var i = 0; i < individual_score.length; i++) {
  //               if (individual_score[i].text == score_data.text) {
  //                 score_present = true;
  //                 break;
  //               }
  //             }
  //             if (!score_present) {
  //               individual_score.push(score_data);
  //             }
  //             var display_name = _.find(projectSelectFields, {
  //               field_name: data.display_name,
  //             }).display_name;

  //             if (selected.text) {
  //               //lowest
  //               recommendations.push({
  //                 score: selected.score * data.weightage,
  //                 text: selected.text,
  //               });
  //               lowest_factors.push({ factor_text: display_name });
  //             } else {
  //               //highest
  //               if (selected.score > 2) {
  //                 highest_factors.push({
  //                   factor_text: display_name,
  //                 });
  //               }
  //             }
  //           }
  //         }
  //       });
  //       pqqStage.forEach((data, index) => {
  //         var e = Object.keys(element).find((key) => key === data.option_names);
  //         if (e) {
  //           var selector = element[e]?.props?.value?.label;
  //           if (selector) {
  //             var elem = getElementFrom(pqqStage, data.option_names);
  //             var selected = getScore(elem, selector);
  //             score = score + selected.score * data.weightage;
  //             var score_data = {
  //               text: selected.label,
  //               score: score,
  //             };
  //             var score_present = false;
  //             for (var i = 0; i < individual_score.length; i++) {
  //               if (individual_score[i].text == score_data.text) {
  //                 score_present = true;
  //                 break;
  //               }
  //             }
  //             if (!score_present) {
  //               individual_score.push(score_data);
  //             }
  //             var display_name = _.find(projectSelectFields, {
  //               field_name: data.display_name,
  //             }).display_name;

  //             if (selected.text) {
  //               //lowest
  //               recommendations.push({
  //                 score: selected.score * data.weightage,
  //                 text: selected.text,
  //               });
  //               lowest_factors.push({ factor_text: display_name });
  //             } else {
  //               //highest
  //               if (selected.score > 2) {
  //                 highest_factors.push({
  //                   factor_text: display_name,
  //                 });
  //               }
  //             }
  //           }
  //         }
  //       });
  //       setGlobalFactorsData({
  //         ...globalFactorsData,
  //         highest_factors: highest_factors,
  //         lowest_factors: lowest_factors,
  //         recommendations: recommendations
  //       });
  //       setHighestFactors(highest_factors);
  //       setLowestFactors(lowest_factors);
  //       setRecomendendColumns(recommendations);
  //       setGlobalOpportunityData((prevData) => ({
  //         ...prevData,
  //         ["win_score"]: score,
  //       }));
  //       const colorSet = setColor(currStage, score, bidStatus);
  //       setColors(colorSet);
  //       setLoading(false)
  //     } else {
  //       setLoading(true)
  //       var score = 0;
  //       bdStage.forEach((data, index) => {
  //         if (data.option_names === pickedElem) {
  //           var e = Object.keys(element).find(
  //             (key) => key === data.option_names
  //           );
  //         } else {
  //           var e = Object.keys(element).find(
  //             (key) => key === data.option_names
  //           );
  //         }

  //         if (e) {
  //           var selector = element[e]?.props?.value?.label;
  //           if (selector) {
  //             var elem = getElementFrom(bdStage, data.option_names);
  //             var selected = getScore(elem, selector);
  //             if (selected) {
  //               score = score + selected.score * data.weightage;
  //               var score_data = {
  //                 text: selected.label,
  //                 score: score,
  //               };
  //             }

  //             var score_present = false;
  //             for (var i = 0; i < individual_score.length; i++) {
  //               if (individual_score[i]?.text == score_data?.text) {
  //                 score_present = true;
  //                 break;
  //               }
  //             }
  //             if (!score_present) {
  //               individual_score.push(score_data);
  //             }
  //             var display_name = _.find(newAndSelectivityList, {
  //               reference_key: data.option_names,
  //             })?.display_name;

  //             if (selected?.text) {
  //               //lowest
  //               recommendations.push({
  //                 score: selected.score * data.weightage,
  //                 text: selected.text,
  //               });
  //               lowest_factors.push({ factor_text: display_name });
  //             } else {
  //               //highest
  //               if (selected?.score > 2) {
  //                 highest_factors.push({
  //                   factor_text: display_name,
  //                 });
  //               }
  //             }
  //           }
  //         }
  //       });
  //       pqqStage.forEach((data, index) => {
  //         var e = Object.keys(element).find((key) => key === data.option_names);
  //         if (e) {
  //           var selector = element[e]?.props?.value?.label;
  //           if (selector) {
  //             var elem = getElementFrom(pqqStage, data.option_names);
  //             var selected = getScore(elem, selector);

  //             if (selected != undefined) {
  //               score = score + selected.score * data.weightage;
  //               var score_data = {
  //                 text: selected.label,
  //                 score: score,
  //               };
  //             }
  //             var score_present = false;
  //             for (var i = 0; i < individual_score.length; i++) {
  //               if (individual_score[i]?.text == score_data?.text) {
  //                 score_present = true;
  //                 break;
  //               }
  //             }
  //             if (!score_present) {
  //               individual_score.push(score_data);
  //             }
  //             var display_name = _.find(newAndSelectivityList, {
  //               reference_key: data.option_names,
  //             })?.display_name;

  //             if (selected?.text) {
  //               //lowest
  //               recommendations.push({
  //                 score: selected.score * data.weightage,
  //                 text: selected.text,
  //               });
  //               lowest_factors.push({ factor_text: display_name });
  //             } else {
  //               //highest
  //               if (selected?.score > 2) {
  //                 highest_factors.push({
  //                   factor_text: display_name,
  //                 });
  //               }
  //             }
  //           }
  //         }
  //       });
  //       ittStage.forEach((data, index) => {
  //         var e = Object.keys(element).find((key) => key === data.option_names);
  //         if (e) {
  //           var selector = element[e]?.props?.value?.label;
  //           if (selector) {
  //             var elem = getElementFrom(ittStage, data.option_names);
  //             var selected = getScore(elem, selector);
  //             if (selected) {
  //               score = score + selected.score * data.weightage;
  //               var score_data = {
  //                 text: selected.label,
  //                 score: score,
  //               };
  //             }

  //             var score_present = false;
  //             for (var i = 0; i < individual_score.length; i++) {
  //               if (individual_score[i]?.text == score_data?.text) {
  //                 score_present = true;
  //                 break;
  //               }
  //             }
  //             if (!score_present) {
  //               individual_score.push(score_data);
  //             }
  //             var display_name = _.find(newAndSelectivityList, {
  //               reference_key: data.option_names,
  //             })?.display_name;

  //             if (selected?.text) {
  //               //lowest
  //               recommendations.push({
  //                 score: selected.score * data.weightage,
  //                 text: selected.text,
  //               });
  //               lowest_factors.push({ factor_text: display_name });
  //             } else {
  //               //highest
  //               if (selected?.score > 2) {
  //                 highest_factors.push({
  //                   factor_text: display_name,
  //                 });
  //               }
  //             }
  //           }
  //         }
  //       });
  //       setGlobalFactorsData({
  //         ...globalFactorsData,
  //         highest_factors: highest_factors,
  //         lowest_factors: lowest_factors,
  //         recommendations: recommendations
  //       });
  //       setHighestFactors(highest_factors);
  //       setLowestFactors(lowest_factors);
  //       setRecomendendColumns(recommendations);
  //       setGlobalOpportunityData((prevData) => ({
  //         ...prevData,
  //         ["win_score"]: score,
  //       }));
  //       const colorSet = setColor(currStage, score, bidStatus);
  //       setColors(colorSet);
  //       setLoading(false)
  //     }
  //     setIndividualScore(individual_score)
  //   }
  //   setLoading(false)
  // };

  const getStages = (allData, selector) => {
    const found = _.filter(allData, { win_stage: selector });
    return found.length ? found : undefined;
  };
  const getElementFrom = (elem, selector) => {
    const found = _.filter(elem, { option_names: selector });
    if (found.length) {
      return found[0];
    }
    return 0;
  };
  const setColor = (stage, score, bidStatus) => {
    let customStyle = {};
    let customStyle2 = {};
    let colorStatus = "";
    let winStatus = "";

    if (stage === "Target" || stage === "Pursuit") {
      if (score <= 50) {
        customStyle = "background-red";
        customStyle2 = "color_red";
        colorStatus = "Stop !";
        winStatus = bidStatus === "Won" ? "Secured" : "Long shot";
      } else if (score > 50 && score <= 74) {
        customStyle = "background-amber";
        customStyle2 = "color_amber";
        colorStatus = "Review";
        winStatus = bidStatus === "Won" ? "Secured" : "Probable";
      } else if (score > 74 && score <= 99) {
        customStyle = "background-amber";
        customStyle2 = "color_amber";
        colorStatus = "Possible";
        winStatus = bidStatus === "Won" ? "Secured" : "Possible";
      } else {
        customStyle = "background-green";
        customStyle2 = "color_green";
        colorStatus = "Go";
        winStatus = bidStatus === "Won" ? "Secured" : "Expected";
      }
    } else if (stage === "Pre-Qualify") {
      if (score <= 104) {
        customStyle = { backgroundColor: "red" };
        customStyle2 = "color_red";
        colorStatus = "Stop !";
        winStatus = bidStatus === "Won" ? "Secured" : "Long shot";
      } else if (score > 104 && score <= 155) {
        customStyle = "background-amber";
        customStyle2 = "color_amber";
        colorStatus = "Review";
        winStatus = bidStatus === "Won" ? "Secured" : "Probable";
      } else if (score > 155 && score <= 207) {
        customStyle = "background-amber";
        customStyle2 = "color_amber";
        colorStatus = "Possible";
        winStatus = bidStatus === "Won" ? "Secured" : "Possible";
      } else {
        customStyle = "background-green";
        customStyle2 = "color_green";
        colorStatus = "Go";
        winStatus = bidStatus === "Won" ? "Secured" : "Expected";
      }
    } else {
      if (score <= 140) {
        customStyle = { backgroundColor: "red" };
        customStyle2 = "color_red";
        colorStatus = "Stop !";
        winStatus = bidStatus === "Won" ? "Secured" : "Long shot";
      } else if (score > 140 && score <= 209) {
        customStyle = "background-amber";
        customStyle2 = "color_amber";
        colorStatus = "Review";
        winStatus = bidStatus === "Won" ? "Secured" : "Probable";
      } else if (score > 209 && score <= 279) {
        customStyle = "background-amber";
        customStyle2 = "color_amber";
        colorStatus = "Possible";
        winStatus = bidStatus === "Won" ? "Secured" : "Possible";
      } else {
        customStyle = "background-green";
        customStyle2 = "color_green";
        colorStatus = "Go";
        winStatus = bidStatus === "Won" ? "Secured" : "Expected";
      }
    }

    return {
      customStyle,
      customStyle2,
      colorStatus,
      winStatus,
    };
  };

  const riskColors = () => {
    var score = riskScores["riskSum"];
    let customStyle;
    let customStyle2;
    let colorStatus;

    if (score <= 33) {
      customStyle = "background-green";
      customStyle2 = "color_green";
      colorStatus = "Low !";
    } else if (score > 33 && score <= 66) {
      customStyle = "background-amber";
      customStyle2 = "color_amber";
      colorStatus = "Medium";
    } else if (score > 66) {
      customStyle = "background-red";
      customStyle2 = "color_red";
      colorStatus = "High";
    }

    setRiskColor({
      customStyle: customStyle,
      customStyle2: customStyle2,
      colorStatus: colorStatus,
    });
  };

  const riskOppColors = () => {
    var score = riskScores["riskOppSum"];
    let customStyle;
    let customStyle2;
    let colorStatus;

    if (score <= 33) {
      customStyle = "background-red";
      customStyle2 = "color_red";
      colorStatus = "Negligible";
    } else if (score > 33 && score <= 66) {
      customStyle = "background-amber";
      customStyle2 = "color_amber";
      colorStatus = "Modest";
    } else if (score > 66) {
      customStyle = "background-green";
      customStyle2 = "color_green";
      colorStatus = "Significant";
    }

    setRiskOppColor({
      customStyle: customStyle,
      customStyle2: customStyle2,
      colorStatus: colorStatus,
    });
  };

  const getScore = (elem, selector) => {
    const found = elem.option_choice.filter((item) => item.label === selector);
    if (found.length) {
      return found[0];
    }
    return;
  };

  const getData = (data) => {
    if (data == "success") {
      getOpportunities();
    }
  };

  const enablingTabs = () => {
    var enableTab = {};
    var userPrivillege = userPrivilleges();

    if (userPrivillege && userPrivillege.isRestricted) {
      for (let tab of appRestrictedTabs) {
        for (let rest of restrictedUserTabs) {
          if (rest.label === tab.label) {
            enableTab[tab.label] = true;
          }
        }
      }
      //For extra tab (save image icon)
      enableTab["save image"] = true;
    } else {
      for (let tab of appRestrictedTabs) {
        enableTab[tab.label] = true;
      }
      //For extra tab (save image icon)
      enableTab["save image"] = true;
    }
    setEnableTabs(enableTab);
  };

  const updateCompetitorList = (newCompetitor) => {
    setOpportunityData((prevData) => {
      // Create the new competitor list
      const updatedList = [
        ...prevData.additional.competitor_list,
        newCompetitor,
      ];

      return {
        ...prevData,
        additional: {
          ...prevData.additional,
          competitor_list: updatedList, // Replace existing list with the new one
        },
      };
    });
  };

  const riskScore = (data) => {
    setRiskScores(data);
  };

  const pendingResponsibilities1 = (data) => {
    setPendingResponsibility((prevState) => {
      const combinedArray = [...prevState, ...data];

      const uniqueArray = combinedArray.reduce((acc, current) => {
        const isDuplicate = acc.some(item => item.resp === current.resp);
        if (!isDuplicate) {
          acc.push(current);
        }
        return acc;
      }, []);
      setNewState(uniqueArray);
      return uniqueArray;
    });

  };

  const pendingResponsibilities2 = (data) => {
    setPendingResponsibility((prevState) => {
      const combinedArray = [...prevState, ...data];

      const uniqueArray = combinedArray.reduce((acc, current) => {
        const isDuplicate = acc.some(item => item.resp === current.resp);
        if (!isDuplicate) {
          acc.push(current);
        }
        return acc;
      }, []);
      setNewState(uniqueArray);
      return uniqueArray;
    });
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab.label);
    setActiveComponent(tab.command);
  };

  useEffect(() => {
    var tabs = [
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Summary"
        ).display_name
          }`,
        icon: "pi pi-list",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Summary"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <Summary
            // ref={childRef}
            // setElement={elementUpdate}
            customerId={customerId}
            opportunityId={opportunityId}
            branch={branch}
            opportunityData={opportunityData}
            scrollToTop={scrollToTop}
            userId={userId}
            stageIndex={stageIndex}
            prevBidLeaderId={prevBidLeaderId}
            computeScore={computeScore}
            bdLongShotRole={bdLongShotRole}
            tenderPeriod={tenderPeriod}
            summaryData={{
              projectFieldsNew: projectFieldsNew,
              projectSumFields: projectSumFields,
              projectSumSections: projectSumSections,
              clientFieldsNew: clientFieldsNew,
              frameworkFieldsNew: frameworkFieldsNew,
              commanFieldsNew: commanFieldsNew,
              projectSelectFields: projectSelectFields
            }}
            clientClassificationV1={clientClassificationV1}
            clientType={clientType}
            sector={sector}
            regions={region}
            frameworkData={frameworkData}
          />
        )
        // })
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Selectivity"
        ).display_name
          }`,
        icon: "pi pi-briefcase",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Selectivity"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <PurposeScore
            // ref={childRef}
            // setElement={elementUpdate}
            opportunityType={opportunityType}
            connectionsToProfessionalTeam={connectionsToProfessionalTeam}
            opportunityData={opportunityData}
            branch={branch}
            computeScore={computeScore}
            clientMeetings={clientMeetings}
            projectFieldsNew={projectFieldsNew}
            ittStage={ittStage}
            pqqStage={pqqStage}
            bdStage={bdStage}
            bidStatus={bidStatus}
            currStage={currStage}
            customerId={customerId}
            projectSumFields={projectSumFields}
            projectSelectFields={projectSelectFields}
            frameworkFieldsNew={frameworkFieldsNew}
            commanFieldsNew={commanFieldsNew}
            projectSelectSections={projectSelectSections}
            workType={workType}
            projectType={projectType}
            sourceOfOpportunity={sourceOfOpportunity}
            workClassificationV2={workClassificationV2}
            formOfContract1={formOfContract1}
            procurementRoute={procurementRoute}
            sector={sector}
            tenderPeriod={tenderPeriod}
            projectValue={projectValue}
            projectDuration={projectDuration}
            risks={risks}
            bimRequirement={bimRequirement}
            fitWithBusinessPlan={fitWithBusinessPlan}
            profile={profile}
            paymentTermsDays={paymentTermsDays}
            winnability={winnability}
            selectionWeightingFactors={selectionWeightingFactors}
            funding={funding}
            regions={region}
            geography={geography}
            businessUnit={businessUnit}
            clientHistory={clientHistory}
            clientClassificationV1={clientClassificationV1}
            clientFieldsNew={clientFieldsNew}
            clientType={clientType}
            depthOfAdvisorEngagement={depthOfAdvisorEngagement}
            resourcingTheBid={resourcingTheBid}
            resourcingTheProject={resourcingTheProject}
            noOfCompetitors={noOfCompetitors}
            bondRequirement={bondRequirement}
            updateCompetitorList={updateCompetitorList}
            lowestFactors={lowestFactors}
            highestFactors={highestFactors}
            recomendendColumns={recomendendColumns}
            projectMargin={projectMargin}
            frameworkLength={frameworkLength}
            enableClienTypeDesc={enableClienTypeDesc}
            frameworkData={frameworkData}
          />
        )
        // }),
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Detail"
        ).display_name
          }`,
        icon: "pi pi-file",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Detail"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <Details
            // ref={childRef}
            // setElement={elementUpdate}
            computeScore={computeScore}
            customerId={customerId}
            opportunityData={opportunityData}
            opportunityId={opportunityId}
            customerTooltipDataDetails={customerTooltipDataDetails}
            frameworkDetails={frameworkDetails}
            currency={currency}
            projectDuration={projectDuration}
            detailsData={{
              projectFieldsNew: projectFieldsNew,
              projectSumFields: projectSumFields,
              projectSelectFields: projectSelectFields,
              // "clientFieldsNew": clientFieldsNew,
              frameworkFieldsNew: frameworkFieldsNew,
              commanFieldsNew: commanFieldsNew,
              projectDetailsSections: projectDetailsSections,
              projectDetailFields: projectDetailFields,
            }}
          />
        )
        // }),
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Metrics"
        ).display_name
          }`,
        icon: "pi pi-gauge",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Metrics"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <Metrics
            opportunityData={opportunityData}
            customerTooltipDataOthers={customerTooltipDataOthers}
            isWonOrLoss={isWonOrLoss}
            customerId={customerId}
            displayValues={displayValues}
            currency={currency}
            criticalheaders={criticalheaders}
            kpiheaders={kpiheaders}
            breeamOptions={breeam}
            fieldData={{
              projectMetricSections: projectMetricSections,
              oppMetricsTable: oppMetricsTable,
              pipelineClientsubmodule: pipelineClientsubmodule,
              projectMetricFields: projectMetricFields,
              oppMetricsHeaders: oppMetricsHeaders,
            }}
            errors={errors}
          />
        )
        // }),
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Client"
        ).display_name
          }`,
        icon: "pi pi-star",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Client"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <Objective
            // ref={childRef}
            // setElement={elementUpdate}
            computeScore={computeScore}
            clientDetails={clientDetails}
            clientType={clientType}
            customerId={customerId}
            opportunityData={opportunityData}
            clientHistory={clientHistory}
            clientMeetings={clientMeetings}
            oppOthersTooltip={oppOthersTooltip}
            pipelineClientsubmodule={pipelineClientsubmodule}
            fieldDetails={fieldDetails}
            getData={getData}
            objectiveData={{
              clientFieldsNew: clientFieldsNew,
              oppClientTable: oppClientTable,
              pipelineClientSections: pipelineClientSections,
              projectSelectFields: projectSelectFields,
              pipelineClientFields: pipelineClientFields,
              oppClientHeaders: oppClientHeaders,
              addressContactFields: addressContactFields,
              commanFieldsNew: commanFieldsNew,
              clientSectionsSummary: clientSectionsAC,
            }}
            errors={errors}
            addressDetails={addressDetails}
          />
        )
        // }),
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Stakeholders"
        ).display_name
          }`,
        icon: "pi pi-desktop",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Stakeholders"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <Stakeholders
            // ref={childRef}
            // setElement={elementUpdate}
            computeScore={computeScore}
            customerDetails={customerDetails}
            fieldDetails={fieldDetails}
            addressDetails={addressDetails}
            clientName={clientName}
            customerId={customerId}
            opportunityId={opportunityId}
            branch={branch}
            branchDetails={branchData}
            branchUsers={branchDetails}
            relationshipOwner={relationshipOwner}
            customerTableData={customerTableData}
            havingBranch={havingBranch}
            branchIdFromLS={branch}
            currency={currency}
            opportunityData={opportunityData}
            userId={userId}
            stageIndex={stageIndex}
            prevBidLeaderId={prevBidLeaderId}
            advisorHistory={advisorHistory}
            depthOfAdvisorEngagement={depthOfAdvisorEngagement}
            customerTooltipSummary={customerTooltipSummary}
            customerTooltipDataOthers={customerTooltipDataOthers}
            getData={getData}
            stakeholderData={{
              projectFieldsNew: projectFieldsNew,
              projectSumFields: projectSumFields,
              projectSumSections: projectSumSections,
              projectStakeTabSections: projectStakeTabSections,
              oppStakeholdersTable: oppStakeholdersTable,
              pipelineStakeSections: pipelineStakeSections,
              clientFieldsNew: clientFieldsNew,
              frameworkFieldsNew: frameworkFieldsNew,
              commanFieldsNew: commanFieldsNew,
              clientSectionsNew: clientSectionsNew,
              pipelineStakeFields: pipelineStakeFields,
              oppListStakeholdersHeaders: oppListStakeholdersHeaders,
              oppIndiStakeholdersHeaders: oppIndiStakeholdersHeaders,
              orgFieldsNew: orgFieldsNew,
              clientFieldsRDS: clientFieldsAC,
              clientSectionsSummary: clientSectionsAC,
              clientSummaryTab: clientACTab,
              clientFieldsNew: clientFieldsNew,
              addressContactFields: addressContactFields,
              pipelineStakesubmodule: pipelineStakesubmodule,
              oppClientHeaders: oppClientHeaders
            }}
            errors={errors}
          />
        )
        // }),
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Risks"
        ).display_name
          }`,
        icon: "pi pi-map",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Risks"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <Risks
            computeScore={computeScore}
            customerId={customerId}
            risks={risks}
            branch={branch}
            oppRisksTable={oppRisksTable}
            oppIdentificationHeaders={oppIdentificationHeaders}
            oppManagementHeaders={oppManagementHeaders}
            oppRiskManagementHeaders={oppRiskManagementHeaders}
            data={data}
            oppRiskIdentificationHeaders={oppRiskIdentificationHeaders}
            riskCategory={riskCategory}
            riskType={riskType}
            opportunityData={opportunityData}
            pipelineRiskSections={pipelineRiskSections}
            projectSelectFields={projectSelectFields}
            pipelineRiskFields={pipelineRiskFields}
            riskScore={riskScore}
            pipelineRisksubmodule={pipelineRisksubmodule}
            relationshipActionOwner={internBidUserFilter}
            relationshipOwner={relationshipOwner}

            // ref={childRef}
            // setElement={elementUpdate}
            getOpportunities={getOpportunities}
            errors={errors}
            customerTooltipRisks={customerTooltipRisks}
          />
        )
        // }),
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Bid Team"
        ).display_name
          }`,
        icon: "pi pi-user-plus",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Bid Team"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <Team
            customerId={customerId}
            opportunityData={opportunityData}
            opportunityId={opportunityId}
            customerTooltipDataDetails={customerTooltipDataDetails}
            bdLongShotRole={bdLongShotRole}
            branch={branch}
            userId={userId}
            getData={getData}
            TeamData={{
              pipelineBidSections: pipelineBidSections,
              tableFieldsBidTeam: tableFieldsBidTeam,
              internalTeamHeaders: internalTeamHeaders,
              externalTeamHeaders: externalTeamHeaders,
              projectSumFields: projectSumFields,
            }}
            relationshipOwner={relationshipOwner}
            errors={errors}
          />
        )
        // }),
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Targets"
        ).display_name
          }`,
        icon: "pi pi-bullseye",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Targets"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <Target
            opportunityData={opportunityData}
            customerTooltipDataOthers={customerTooltipDataOthers}
            customerId={customerId}
            userFilterReports={userFilterReports}
            customerTooltipDataDetails={customerTooltipDataDetails}
            internBidUserFilter={internBidUserFilter}
            goalType={goalType}
            reference_data={data}
            unitOfMeasurement={unitOfMeasurement}
            attribution={attribution}
            fieldData={{
              pipelineLogFrameSections: pipelineLogFrameSections,
              pipelineLogFrameFields: pipelineLogFrameFields,
              pipelineLogFramesubmodule: pipelineLogFramesubmodule,
              projectSumFields: projectSumFields,
              oppTargetTable: oppTargetTable,
              customerTooltipRisks: customerTooltipRisks,
              oppTargetHeaders: oppTargetHeaders,
            }}
            errors={errors}
          />
        )
        // }),
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Project Team"
        ).display_name
          }`,
        icon: "pi pi-users",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Project Team"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <ProjectTeam
            customerId={customerId}
            risks={risks}
            branch={branch}
            oppProjectTeamTable={oppProjectTeamTable}
            oppProjectTeamHeaders={oppProjectTeamHeaders}
            oppRiskIdentificationHeaders={oppRiskIdentificationHeaders}
            deliveryTeamRoles={deliveryTeamRoles}
            riskType={riskType}
            opportunityData={opportunityData}
            pipelineTeamSections={pipelineTeamSections}
            projectTeamTab={projectTeamTab}
            projectSelectFields={projectSelectFields}
            pipelineRiskFields={pipelineRiskFields}
            errors={errors}
          />
        )
        // }),
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Winplan"
        ).display_name
          }`,
        icon: "pi pi-ellipsis-h",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Winplan"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <ActivityPlannar
            opportunityData={opportunityData}
            customerId={customerId}
            testSections={testSections}
            rdsScore={rdsScore}
            customerTooltipDataOthers={customerTooltipDataOthers}
            winPlanSection={winPlanSection}
            reference_data={data}
            relationshipOwner={relationshipOwner}
            modelNew={modelNew}
            planData={planData}
            getData={getData}
            riskScores={riskScores}
            fieldData={{
              pipelineWinplanSections: pipelineWinplanSections,
              oppWinPlanTable: oppWinPlanTable,
              pipelineWinplansubmodule: pipelineWinplansubmodule,
              oppProjectTeamTable: oppProjectTeamTable,
              pipelineWinplanFields: pipelineWinplanFields,
              oppWinplanIdenHeaders: oppWinplanIdenHeaders,
              oppWinplanManageHeaders: oppWinplanManageHeaders,
              oppClientTable: oppClientTable,
            }}
            errors={errors}
          />
        )
        // }),
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Submission Management"
        ).display_name
          }`,
        icon: "pi pi-wallet",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Submission Management"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <QuestionAndAnswer
            opportunityData={opportunityData}
            customerTooltipDataDetails={customerTooltipDataDetails}
            relationshipOwner={relationshipOwner}
            submissionDocStatus={submissionDocStatus}
            fieldData={{
              pipelineSubSections: pipelineSubSections,
              projectDetailFields: projectDetailFields,
              pipelineSubFields: pipelineSubFields,
              oppSubmissionManagementTable: oppSubmissionManagementTable,
              oppSubmissionManagementHeaders: oppSubmissionManagementHeaders,
              submissionLabels: submissionLabels,
            }}
          />
        )
        // }),
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Client Plan"
        ).display_name
          }`,
        icon: "pi pi-clipboard",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Client Plan"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <RelationshipManager
            opportunityData={opportunityData}
            customerId={customerId}
            shortName={shortName}
            currVersion={currVersion}
            customerTooltipDataOthers={customerTooltipDataOthers}
            clientData={{
              clientPlan: clientPlan,
              initiativeSelected: initiativeSelected,
              clientPlanSectionNew: clientPlanSectionNew,
            }}
            branchData={branch}
            fieldsData={{
              pipelinePlanSections: pipelinePlanSections,
              clientFieldsNew: clientFieldsNew,
              clientPlanFieldsNew: clientPlanFieldsNew,
              clientPlanTable: clientPlanTable,
              oppClientPlanTable: oppClientPlanTable,
              oppClientPlanDocHeaders: oppClientPlanDocHeaders,
              oppClientPlanInitHeaders: oppClientPlanInitHeaders,
            }}
          />
        )
        // }),
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Ways of Winning"
        ).display_name
          }`,
        icon: "pi pi-chart-line",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Ways of Winning"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <PromptsAndChecklists
            opportunityData={opportunityData}
            fieldData={{
              pipelineWinningSections: pipelineWinningSections,
              oppWaysOfWinningTable: oppWaysOfWinningTable,
              oppWaysOfWinningHeaders: oppWaysOfWinningHeaders,
            }}
            pendingResponsibility={pendingResponsibilities1}
          />
        )
        // }),
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Reviews"
        ).display_name
          }`,
        icon: "pi pi-verified",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Reviews"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <ReviewAndGovernance
            opportunityData={opportunityData}
            customerTooltipDataOthers={customerTooltipDataOthers}
            customerId={customerId}
            stageIndex={stageIndex}
            reference_data={data}
            midStage={midStage}
            midStageIndex={midStageIndex}
            winstages={winstages}
            individualScore={individualScore}
            // saveOpp={saveopportunity}
            fieldData={{
              pipelineReviewSections: pipelineReviewSections,
              oppReviewsTable: oppReviewsTable,
              oppReviewsActionHeaders: oppReviewsActionHeaders,
              oppReviewsApprovalHeaders: oppReviewsApprovalHeaders,
              oppReviewsCompletedHeaders: oppReviewsCompletedHeaders,
            }}
            pendingResponsibility={pendingResponsibilities2}
          />
        )
        // }),
      },
      {
        label: `${projectModules.sub_modules?.find(
          (project) => project.sub_module_name === "Gateways"
        ).display_name
          }`,
        icon: "pi pi-sliders-h",
        // command: () => handleTabClick({
        //   label: `${projectModules.sub_modules?.find(
        //     (project) => project.sub_module_name === "Gateways"
        //   ).display_name
        //     }`,
        //   command: (
        Component: (
          <Milestones
            opportunityData={opportunityData}
            customerId={customerId}
            customerTooltipGateway={customerTooltipGateway}
            winWorkStage={winWorkStage}
            winstages={winstages}
            individualScore={individualScore}
            fieldData={{
              pipelineGatewaysSections: pipelineGatewaysSections,
              oppGatewaysTable: oppGatewaysTable,
              oppGatewaysHeaders: oppGatewaysHeaders,
            }}
          // saveOpp={saveopportunity}
          />
        )
        // }),
      },
      {
        label: "Qualitative",
        icon: "pi pi-calculator",
        Component: (
          <Qualitative
            opportunityData={opportunityData}
            customerId={customerId}

            customerTooltipDataOthers={customerTooltipDataOthers}
            userFilterReports={userFilterReports}
            customerTooltipDataDetails={customerTooltipDataDetails}
            internBidUserFilter={internBidUserFilter}
            goalType={goalQualitativeType}
            reference_data={data}
            score={score}
            attribution={attribution}
            fieldData={{
              oppQualitativeHeaders: oppQualitativeHeaders,
              oppQualitativeTable: oppQualitativeTable,
              pipelineLogFrameSections: pipelineLogFrameSections,
              pipelineLogFrameFields: pipelineLogFrameFields,
              pipelineLogFramesubmodule: pipelineLogFramesubmodule,
              projectSumFields: projectSumFields,
              customerTooltipRisks: customerTooltipRisks,
              pipelineQualitativeHeader: pipelineQualitativeHeader,
            }}
            errors={errors}
          />
        )
        // }),
      },
    ];
    var newItems = [];
    if (tabPermissions["Summary"] && enableTabs["Summary"]) {
      newItems.push(tabs[0]);
    }
    if (tabPermissions["Selectivity"] && enableTabs["Selectivity"]) {
      newItems.push(tabs[1]);
    }
    if (tabPermissions["Detail"] && enableTabs["Detail"]) {
      newItems.push(tabs[2]);
    }
    if (tabPermissions["Metrics"] && enableTabs["Metrics"]) {
      newItems.push(tabs[3]);
    }
    if (tabPermissions["Client"] && enableTabs["Client"]) {
      newItems.push(tabs[4]);
    }
    if (tabPermissions["Stakeholders"] && enableTabs["Stakeholders"]) {
      newItems.push(tabs[5]);
    }
    if (tabPermissions["Risks"] && enableTabs["Risks"]) {
      newItems.push(tabs[6]);
    }
    if (tabPermissions["Bid Team"] && enableTabs["Bid Team"]) {
      newItems.push(tabs[7]);
    }
    if (tabPermissions["Logframe Targets"] && enableTabs["Logframe Targets"]) {
      newItems.push(tabs[8]);
    }
    if (tabPermissions["Qualitative"] && enableTabs["Qualitative"]) {
      newItems.push(tabs[16]);
    }
    if (tabPermissions["Project Team"] && enableTabs["Project Team"]) {
      newItems.push(tabs[9]);
    }
    if (tabPermissions["winPlan"] && enableTabs["Win Plan"]) {
      newItems.push(tabs[10]);
    }
    if (tabPermissions["Submission Management"] && enableTabs["Submission Management"]) {
      newItems.push(tabs[11]);
    }
    if (tabPermissions["Client Plan"] && enableTabs["Client Plan"]) {
      newItems.push(tabs[12]);
    }
    if (tabPermissions["Ways of Winning"] && enableTabs["Ways of Winning"]) {
      newItems.push(tabs[13]);
    }
    if (tabPermissions["Reviews"] && enableTabs["Reviews"]) {
      newItems.push(tabs[14]);
    }
    if (tabPermissions["Gateways"] && enableTabs["Gateways"]) {
      newItems.push(tabs[15]);
    }
    setItems(newItems);
  }, [
    projectModules,
    opportunityData,
    clientMeetings,
    tabPermissions,
    enableTabs,
    tableFieldsBidTeam,
    internalTeamHeaders,
    externalTeamHeaders,
    bdLongShotRole,
    clientPlanSectionNew,
    currVersion,
    pipelineWinningSections,
    pipelineClientSections,
    clientDetails,
    errors,
    relationshipOwner
  ]);
  const updates = (e) => {
    setActiveIndex(e.index);
  };

  const getPlanDetail = async () => {
    try {
      var response = await getPlanDetails(pricingPlan);
      if (
        response &&
        response.data.plan_type == "Free" ||
        response.data.plan_type == "Individual" ||
        response.data.plan_type == "Team"
      ) {
        setIsMultiBox(false);
        setIsSingleBox(true);
      } else {
        setIsMultiBox(true);
        setIsSingleBox(false);
      }
      setPlanType(response.data.plan_type);
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  const showErrors = (value) => {
    var error = []
    var tabName = []
    if (globalOpportunityData?.metrics?.displayValues?.length > 0) {
      globalOpportunityData?.metrics?.displayValues?.forEach((displa, index) => {
        displa?.disp?.forEach((display, ind) => {
          if (display.areas == '') {
            error.push('Areas');
            tabName.push('Metrics')
          }
        });
      })
    }
    if (globalOpportunityData?.metrics?.displayValues2?.length > 0) {
      globalOpportunityData?.metrics?.displayValues2?.forEach((display, index) => {
        if (display.areas == '') {
          error.push('Building Performance Title');
          tabName.push('Metrics')
        }
      })
    }
    if (globalOpportunityData?.metrics?.displayValues3?.length > 0) {
      globalOpportunityData?.metrics?.displayValues3?.forEach((displa, index) => {
        displa?.schedule?.forEach((display, ind) => {
          if (display.areas == '') {
            error.push('Accomdations Title');
            tabName.push('Metrics')
          }
        });
      })
    }
    if (globalOpportunityData?.win_plan?.client_evaluation_criteria?.length > 0) {
      globalOpportunityData?.win_plan?.client_evaluation_criteria?.forEach((client, index) => {
        if (client.criteria == '') {
          error.push('Client Evaluation Criteria');
          tabName.push('Metrics')
        }
      })
    }
    if (globalOpportunityData?.client?.opportunity_needs?.length > 0) {
      globalOpportunityData?.client?.opportunity_needs?.forEach((client, index) => {
        if (client.needs == '') {
          error.push('Opportunity Needs');
          tabName.push('Objectives')
        }
      })
    }
    if (globalOpportunityData?.client?.opportunity_objectives?.length > 0) {
      globalOpportunityData?.client?.opportunity_objectives?.forEach((client, index) => {
        if (client.objectives == '') {
          error.push('Opportunity Objectives');
          tabName.push('Objectives')
        }
      })
    }
    if (globalOpportunityData?.client?.opportunity_values?.length > 0) {
      globalOpportunityData?.client?.opportunity_values?.forEach((client, index) => {
        if (client.values == '') {
          error.push('Opportunity Values');
          tabName.push('Objectives')
        }
      })
    }
    if (globalOpportunityData?.win_plan?.project_needs?.length > 0) {
      globalOpportunityData?.win_plan?.project_needs?.forEach((client, index) => {
        if (client.needs == '') {
          error.push('Project Needs');
          tabName.push('Objectives')
        }
      })
    }
    if (globalOpportunityData?.win_plan?.project_objectives?.length > 0) {
      globalOpportunityData?.win_plan?.project_objectives?.forEach((client, index) => {
        if (client.objectives == '') {
          error.push('Project Objectives');
          tabName.push('Objectives')
        }
      })
    }
    if (globalOpportunityData?.win_plan?.project_values?.length > 0) {
      globalOpportunityData?.win_plan?.project_values?.forEach((client, index) => {
        if (client.values == '') {
          error.push('Project Values');
          tabName.push('Objectives')
        }
      })
    }
    if (globalOpportunityData?.advisor?.length > 0) {
      globalOpportunityData?.advisor?.forEach((adv, index) => {
        adv?.advisor_needs?.forEach((need, ind) => {
          if (need.needs == '') {
            error.push('Stakeholder Needs');
            tabName.push('Stakeholders')
          }
        });
      })
    }
    if (globalOpportunityData?.advisor?.length > 0) {
      globalOpportunityData?.advisor?.forEach((adv, index) => {
        adv?.advisor_objectives?.forEach((need, ind) => {
          if (need.objectives == '') {
            error.push('Stakeholder Objectives');
            tabName.push('Stakeholders')
          }
        });
      })
    }
    if (globalOpportunityData?.advisor?.length > 0) {
      globalOpportunityData?.advisor?.forEach((adv, index) => {
        adv?.advisor_values?.forEach((need, ind) => {
          if (need.values == '') {
            error.push('Stakeholder Values');
            tabName.push('Stakeholders')
          }
        });
      })
    }
    if (globalOpportunityData?.risk_identification?.length > 0) {
      globalOpportunityData?.risk_identification?.forEach((risk, index) => {
        risk?.risk_details?.forEach((detail, ind) => {
          if (detail.risk_category == '') {
            error.push('Risk Category');
            tabName.push('Risks')
          }
        });
      })
    }
    if (globalOpportunityData?.opportunity_identification?.length > 0) {
      globalOpportunityData?.opportunity_identification?.forEach((opp, index) => {
        if (opp.category == '') {
          error.push('Category');
          tabName.push('Risks')
        }
      })
    }
    if (globalOpportunityData?.ie_bid_team?.internal_bid_team?.length > 0) {
      globalOpportunityData?.ie_bid_team?.internal_bid_team?.forEach((int, index) => {
        if (int.bid_team_role == undefined) {
          error.push('Bid Team Role');
          tabName.push('Team')
        }
      })
    }
    if (globalOpportunityData?.ie_bid_team?.external_bid_team?.length > 0) {
      globalOpportunityData?.ie_bid_team?.external_bid_team?.forEach((ext, index) => {
        if (ext.external_organisation == '' || ext.service_description == '' || ext.estimated_cost == '') {
          error.push('External Organisation');
          tabName.push('Team')
        }
      })
    }
    if (globalOpportunityData?.goal_identification?.length > 0) {
      globalOpportunityData?.goal_identification?.forEach((goal, index) => {
        goal?.goal_details?.forEach((detail, ind) => {
          if (detail.target == undefined) {
            error.push('Target');
            tabName.push('Targets')
          }
        });
      })
    }
    if (globalOpportunityData?.delivery_team_role?.team_roles?.length > 0) {
      globalOpportunityData?.delivery_team_role?.team_roles?.forEach((team, index) => {
        if (team.role == '' || team.how_many_roles == '' || team.perc_of_time == '') {
          error.push('Delivery Team Role');
          tabName.push('Project Team')
        }
      })
    }
    if (globalOpportunityData?.win_plan?.case_studies_required?.length > 0) {
      globalOpportunityData?.win_plan?.case_studies_required?.forEach((caseStudy, index) => {
        if (caseStudy.case_studies == '') {
          error.push('Case Studies Required');
          tabName.push('Activity Planner')
        }
      })
    }
    if (globalOpportunityData?.win_plan?.testimonial_required?.length > 0) {
      globalOpportunityData?.win_plan?.testimonial_required?.forEach((test, index) => {
        if (test.testimonial == '') {
          error.push('Testimonial Required');
          tabName.push('Activity Planner')
        }
      })
    }
    setErrors(error)
    setTabName(tabName)
    return error
  }

  const notifySave = async () => {
      socket.emit("opportunityEdit", {
          customer_id: globalOpportunityData.customer_id,
          opp_id: opportunityData._id,
          firstname: userRef.current.firstname,
          lastname: userRef.current.lastname,
      });
  };

  const saveopportunity = async () => {
    notifySave();
    setIsEdited(false)
    var result = showErrors()
    var msg = ''
    if (result.length == 1) {
      msg = " is required / invalid field"
    } else if (result.length > 1) {
      msg = " fields are required / invalid";
    }

    var inCompleteActionIds = [];
    globalOpportunityData?.risk_identification?.map((element) => {
      element.risk_details.forEach((item) => {
        if (item.isCompleted == false) {
          inCompleteActionIds.push(item._id);
        }
      });
    });
    globalOpportunityData?.win_plan_section_new?.map((element) => {
      element.theme.forEach((item) => {
        if (item.isCompleted == false) {
          inCompleteActionIds.push(item._id);
        }
      });
    });
    globalOpportunityData?.goal_identification?.map((element) => {
      element.goal_details.forEach((item) => {
        if (item.status == false) {
          inCompleteActionIds.push(item._id);
        }
      });
    });

    globalOpportunityData?.reviews_head?.map((element) => {
      element.review_check_list.forEach((item) => {
        if (item.is_completed == false) {
          inCompleteActionIds.push(item._id);
        }
      });
    });
    globalOpportunityData?.reviews_head?.map((element) => {
      element.review_check_list.forEach((item) => {
        if (item.is_completed == false) {
          inCompleteActionIds.push(item._id);
        }
      });
    });

    // static id for ready for client state in submission management
    globalOpportunityData?.documents?.map((element) => {
      element.questions.forEach((val) => {
        val.sub_questions.forEach((item) => {
          // if (item.status != "5c0e530eb569b860401e0fbd") {
          inCompleteActionIds.push(item._id);
          // }
        });
      });
    });

    var filteredData = winWorkStage.find(
      item => item.label === globalOpportunityData.winwork_stage
    );

    if (filteredData != undefined) {
      globalOpportunityData.winwork_display = filteredData.text
    }

    if (result.length > 0) {
      const uniqueArray = [...new Set(result)];
      toastRef.current.showToast({
        type: "error",
        message: uniqueArray + msg
      });
    } else {
      if (
        globalOpportunityData.bid_team?.status_update_logsdate !== "status update" && globalOpportunityData != undefined
      ) {
        const saveStageResponse = await saveStage(
          globalOpportunityData._id,
          globalOpportunityData
        );
        const updateResponse = await update(
          globalOpportunityData._id,
          globalOpportunityData
        );
        if (saveStageResponse && saveStageResponse.data.success) {
          toastRef.current.showToast({
            type: "success",
            message: saveStageResponse.data.message,
          });
        }
        if (saveStageResponse && saveStageResponse.data && saveStageResponse.data.success && updateResponse && updateResponse.data && updateResponse.data.success) {
          getOpportunities()
        }
        if (updateResponse && updateResponse.data.success) {
          var reThrow = await reThrowNotification(inCompleteActionIds)
          if (reThrow.data) {
            if (reThrow.data.status) {
              inCompleteActionIds = []
              socket.emit('pushNotifications', customerId)
            }
          }
          toastRef.current.showToast({
            type: "success",
            message: updateResponse.data.message,
          });
          var notifyPending = await pendingNotifications(customerId, globalOpportunityData._id)
          if (notifyPending && notifyPending.data) {
            if (notifyPending.data.status) {
              socket.emit('pushNotifications', customerId)
            }
          }
        }
      } else {
        const saveStageResponse = await saveStage(
          globalOpportunityData._id,
          globalOpportunityData
        );
        const updateResponse = await update(
          globalOpportunityData._id,
          globalOpportunityData
        );
        if (saveStageResponse && saveStageResponse.data.success) {
          toastRef.current.showToast({
            type: "success",
            message: saveStageResponse.data.message,
          });
        }
        if (updateResponse && updateResponse.data.success) {
          var reThrow = await reThrowNotification(inCompleteActionIds)
          if (reThrow.data) {
            if (reThrow.data.status) {
              inCompleteActionIds = []
              socket.emit('pushNotifications', customerId)
            }
          }
          toastRef.current.showToast({
            type: "success",
            message: updateResponse.data.message,
          });
          var notifyPending = await pendingNotifications(customerId, globalOpportunityData._id)
          if (notifyPending && notifyPending.data) {
            if (notifyPending.data.status) {
              socket.emit('pushNotifications', customerId)
            }
          }
        }
        if (saveStageResponse && saveStageResponse.data && saveStageResponse.data.success && updateResponse && updateResponse.data && updateResponse.data.success) {
          getOpportunities()
        }
      }
    }
  };

  const setFavourite = () => {
    setOpportunityData((prevState) => ({
      ...prevState,
      isFavourite: !prevState.isFavourite,
    }));
  };

  const handleScrollClick = (event) => {
    event.preventDefault();
    scrollToTop();
  };

  useEffect(() => {
    if (!open) {
      if (items.length > 0) {
        var newItems = [];
        items.forEach((item) => {
          var icons = {
            icon: item.icon,
            Component: item.Component,
          };
          newItems.push(icons);
          setNewItems(newItems);
        });
      }
    }
  }, [open]);

  const toggleOpen = (data) => {
    setopen(data);
  };

  return (
    <>
      <div ref={targetRef} className="target-div" ></div>
      <div className="mt-20">
        <ButtonElement className="scroll-top save-button" title="Scroll to Top" icon="pi pi-arrow-up" onClick={handleScrollClick} />
        <ToastElement ref={toastRef} />
        <Loader loading={loading} />
        <div className="flex justify-content-between">
          <p className="fs-16 fw-600 mar-b-3">
            {opportunityData.opportunity_name}
            {!opportunityData.isFavourite ? (
              <InputIcon
                className="pi pi-star ml-10 pointer"
                onClick={setFavourite}
              />
            ) : (
              <InputIcon
                className="pi pi-star-fill ml-10 pointer"
                onClick={setFavourite}
              />
            )}
          </p>
          <div className="flex flex-row-reverse  align-items-center gap-1 w-25 ">
          <ButtonElement
              type="button"
              className="save-button"
              label="Save"
              onClick={saveopportunity}
            />
          <div className="flex gap-1">
            <div className="text-s ml-2 mt-0">{activeusers? "Active users :" : ""} </div>
                  {activeusers?.map((user, index) => (
                    <span
                      key={index}
                      className="col-md-1 col-sm-1 col-xs-1 img-responsive"
                      data-tooltip-content={user.name}
                      data-tooltip-id={`tooltip-${index}`}
                    >
                      <Avatar
                        name={user.initial || "NA"}
                        color={"#FF0000" || "#000"}
                        fgColor="white"
                        round={true}
                        size="70"
                        maxInitials={3}
                        className="avatar-img"
                      /> 
                      {/* <Tooltip id={`tooltip-${index}`} className="pointer" place="right"/> */}
                    </span>
                  ))}
                </div>
            
            <div>
              <TeamChat globalOpportunityData={globalOpportunityData} />
            </div>
          </div>
        </div>
        <ProgressSteps
          winWorkStage={winWorkStage}
          opportunityData={globalOpportunityData}
          planType={planType}
          isStop={isStop}
          statusPrivilege={statusPrivilege}
        />
        <div className="mt-20">
          <PortfolioCards
            winScore={winScore}
            opportunityData={opportunityData}
            color={color}
            rdsScore={rdsScore}
            currency={currency}
            isSingleBox={isSingleBox}
            isMultiBox={isMultiBox}
            colorRDSStatus={colorRDSStatus}
            riskScores={riskScores}
            riskOppColor={riskOppColor}
            riskColor={riskColor}
            sectionPermissions={sectionPermissions}
            pendingResponsibility={newState}
          />
        </div>
        <div className={open ? "mt-20 portfolio-tabs" : !globalSidebarData ? "mt-20 portfolio-tabs collapse-tabs" : "mt-20 portfolio-tabs collapse-tabs"}>
          <TabElement
            items={open ? items : newItems}
            activeIndex={activeIndex}
            onTabChange={(e) => updates(e)}
            errors={tabName}
            openTab={open}
            setOpen={toggleOpen}
            mainModules={true}
          />
          {/* <div>{items[activeIndex] && items[activeIndex].Component}</div> */}
        </div>
        {/* <div className="portfolio-content">
          <div className="portfolio-menu">
            {
              items.map((item, index) => {
                const isActive = activeTab === item.label;
                const hasError = (tabName != undefined && tabName.length > 0) ? tabName.includes(item.label) : false
                return (
                  <div key={index} className={hasError ? 'error-tab' : isActive ? 'active-menu-item' : ''}>
                    <Menu model={[{ ...item, command: () => handleTabClick(item) }]} />
                  </div>
                )
              })
            }
          </div>
          <div className="portfolio-menu-content" key={JSON.stringify(errors)}>
            {activeComponent}
          </div>
        </div> */}
      </div>
    </>
  );
};

export default PortfolioList;
